<template>
  <div>
    <b-container fluid class="mt-3">

      <!-- Toolbar: solo los filtros que acepta el servicio -->
      <div class="px-3 pt-3">
        <div class="d-flex flex-wrap align-items-end filtros-toolbar">

          <!-- Empresa -->
          <div class="mr-3 mb-2 filtro-item d-flex align-items-center">
            <template v-if="showEmpresaBadge">
              <span class="small text-muted mr-2">{{ $t('empresa') }}:</span>
              <span class="badge badge-primary px-3 text-uppercase" style="display:inline-flex;align-items:center;height:32px;font-size:.85rem;">{{ nombreEmpresaSeleccionada || '—' }}</span>
            </template>
            <template v-else>
              <div>
                <label class="small mb-1 d-block">{{ $t('empresa') }}</label>
                <el-select style="width:220px;"
                  v-model="empresaSeleccionada"
                  filterable
                  :placeholder="$t('todas')"
                  @change="onEmpresaChange"
                  @clear="empresaSeleccionada = 0; onEmpresaChange()"
                  :disabled="cargando"
                  clearable
                  size="small">
                  <el-option v-if="rol !== 'cliente'" :value="0" :label="$t('todas')"></el-option>
                  <el-option v-for="e in empresas" :key="'emp-'+e.id" :label="e.nombre" :value="e.id" />
                </el-select>
              </div>
            </template>
          </div>

          <!-- Tipo Vista -->
          <div class="mr-3 mb-2 filtro-item">
            <label class="small mb-1 d-block">{{ $t('tipo_vista') }}</label>
            <el-select style="width:200px;" v-model="tipoVista" :disabled="cargando" size="small">
              <el-option value="" :label="$t('seleccionar')" />
              <el-option value="inventario" :label="$t('inventario_label')" />
              <el-option value="ecommerce" :label="$t('publicado_ecommerce')" />
              <!-- "visita" es un perfil de solo lectura: ve estas vistas, pero la
                   edición dentro de ellas queda bloqueada por `puedeEscribir`. -->
              <el-option v-if="['admin','ventas inex','operaciones','visita'].includes(rol)" value="maestro_materiales" :label="$t('maestro_materiales')" />
              <el-option v-if="['admin','ventas inex','operaciones','visita'].includes(rol)" value="pre_maestro_materiales" :label="$t('pre_maestro_materiales')" />
            </el-select>
          </div>

          <!-- Búsqueda Maestro Materiales -->
          <div v-if="tipoVista === 'maestro_materiales'" class="mr-3 mb-2 filtro-item">
            <label class="small mb-1 d-block">{{ $t('buscar_en_bd') }}</label>
            <input
              type="text"
              class="form-control form-control-sm"
              style="width:220px;"
              v-model="maestroSearch"
              :disabled="cargando"
              :placeholder="$t('buscar_en_bd')"
              @keyup.enter="onMaestroSearchChange"
            />
          </div>

          <!-- Ordenar Por Maestro Materiales -->
          <div v-if="tipoVista === 'maestro_materiales'" class="mr-3 mb-2 filtro-item">
            <label class="small mb-1 d-block">{{ $t('ordenar_por') }}</label>
            <el-select style="width:220px;" v-model="maestroSortBy" :disabled="cargando" size="small">
              <el-option value="nombre_corto" :label="$t('col_partName') + ' (A-Z)'" />
              <el-option value="fabricante" :label="$t('fabricante') + ' (A-Z)'" />
              <el-option value="part_number" :label="$t('col_part_number') + ' (A-Z)'" />
              <el-option value="fecha_desc" :label="$t('orden_fecha_desc')" />
              <el-option value="fecha_asc" :label="$t('orden_fecha_asc')" />
            </el-select>
          </div>

          <!-- Búsqueda Pre Maestro Materiales -->
          <div v-if="tipoVista === 'pre_maestro_materiales'" class="mr-3 mb-2 filtro-item">
            <label class="small mb-1 d-block">{{ $t('buscar_en_bd') }}</label>
            <input
              type="text"
              class="form-control form-control-sm"
              style="width:220px;"
              v-model="preMaestroSearch"
              :disabled="cargando"
              :placeholder="$t('buscar_en_bd')"
              @keyup.enter="onPreMaestroSearchChange"
            />
          </div>

          <!-- Estado Pre Maestro Materiales -->
          <div v-if="tipoVista === 'pre_maestro_materiales'" class="mr-3 mb-2 filtro-item">
            <label class="small mb-1 d-block">{{ $t('estado') }}</label>
            <el-select style="width:160px;" v-model="preMaestroEstado" :disabled="cargando" size="small" @change="onPreMaestroSearchChange">
              <el-option value="pendientes" :label="$t('pendientes')" />
              <el-option value="integrados" :label="$t('integrados')" />
              <el-option value="todos" :label="$t('todos')" />
            </el-select>
          </div>

          <!-- Buscar -->
          <div class="mr-3 mb-2 filtro-item">
            <label class="small mb-1 d-block">&nbsp;</label>
            <button
              class="btn btn-sm btn-primary"
              style="height:32px;"
              @click="buscar"
              :disabled="cargando || !tipoVista">
              <i class="fas fa-search mr-1" aria-hidden="true"></i>
              {{ $t('buscar') }}
            </button>
          </div>

          <!-- Acciones -->
          <div class="ml-auto mb-2 acciones-toolbar">
            <button
              v-if="puedeEscribir && (false)"
              class="btn btn-sm btn-primary mr-2"
              @click="abrirNuevoPreMaestro"
              :disabled="cargando"
              :title="$t('nuevo')">
              <i class="fas fa-plus mr-1" aria-hidden="true"></i>
              {{ $t('nuevo') }}
            </button>
            <button
              v-if="puedeEscribir && tipoVista === 'pre_maestro_materiales'"
              class="btn btn-sm btn-primary mr-2"
              @click="$refs.inputImportPreMaestro.click()"
              :disabled="cargando || importandoPreMaestro"
              :title="$t('importar_excel')">
              <b-spinner small v-if="importandoPreMaestro" class="mr-1" />
              <i v-else class="fas fa-file-import mr-1" aria-hidden="true"></i>
              {{ $t('importar_excel') }}
            </button>
            <input ref="inputImportPreMaestro" type="file" accept=".xlsx,.xls" class="d-none"
              @change="onImportarPreMaestroFile" />
            <button
              v-if="puedeEscribir && tipoVista === 'pre_maestro_materiales'"
              class="btn btn-sm btn-outline-secondary mr-2"
              @click="descargarPlantillaPreMaestro"
              :disabled="cargando"
              :title="$t('descargar_plantilla')">
              <i class="fas fa-download mr-1" aria-hidden="true"></i>
              {{ $t('plantilla') }}
            </button>
            <!-- No sube archivo: lee el inventario ya cargado y trae lo que falta catalogar -->
            <button
              v-if="puedeEscribir && tipoVista === 'pre_maestro_materiales'"
              class="btn btn-sm btn-info mr-2"
              @click="procesarPreMaestroDesdeEtl"
              :disabled="cargando || validandoPreMaestro"
              :title="$t('validar_e_ingresar_ayuda')">
              <b-spinner small v-if="validandoPreMaestro" class="mr-1" />
              <i v-else class="fas fa-boxes mr-1" aria-hidden="true"></i>
              {{ $t('validar_e_ingresar') }}
            </button>
            <button
              class="btn btn-sm btn-success"
              @click="exportarExcel"
              :disabled="cargando || !tipoVista || (tipoVista === 'inventario' ? !materialTotal : tipoVista === 'ecommerce' ? ecommerceRows.length === 0 : tipoVista === 'pre_maestro_materiales' ? !preMaestroTotal : !maestroTotal)"
              :title="$t('exportar_excel')">
              <i class="fas fa-file-excel mr-1" aria-hidden="true"></i>
              XLS
            </button>
            <!-- Ayuda de la pantalla: que hace cada boton y con que reglas -->
            <button
              v-if="tipoVista === 'pre_maestro_materiales'"
              class="btn btn-sm btn-link text-info ml-2 p-0"
              @click="mostrarInfoPreMaestro"
              :title="$t('pm_info_titulo')">
              <i class="fas fa-info-circle" style="font-size:1.15rem;" aria-hidden="true"></i>
            </button>

            <!-- Las dos integraciones van juntas y separadas del resto: escriben en el Maestro de
                 Materiales, que es un paso de otra naturaleza que cargar o exportar. -->
            <span v-if="puedeEscribir && tipoVista === 'pre_maestro_materiales'" class="separador-acciones"></span>
            <button
              v-if="puedeEscribir && tipoVista === 'pre_maestro_materiales' && mostrarSeleccionPreMaestro"
              class="btn btn-sm btn-primary mr-2"
              @click="integrarPreMaestroAMM"
              :disabled="cargando || preMaestroSelectedIds.length === 0"
              :title="$t('integrar_a_mm')">
              <i class="fas fa-arrow-right mr-1" aria-hidden="true"></i>
              {{ $t('integrar_a_mm') }} ({{ preMaestroSelectedIds.length }})
            </button>
            <button
              v-if="puedeEscribir && tipoVista === 'pre_maestro_materiales'"
              class="btn btn-sm btn-warning"
              @click="integrarTodoPreMaestroAMM"
              :disabled="cargando || integrandoTodo"
              :title="$t('integrar_todo_ayuda')">
              <b-spinner small v-if="integrandoTodo" class="mr-1" />
              <i v-else class="fas fa-angle-double-right mr-1" aria-hidden="true"></i>
              {{ $t('integrar_todo') }}
            </button>
          </div>
        </div>
      </div>

      <!-- Cargando -->
      <div v-if="cargando" class="alert alert-info mx-3 mt-2">
        <span class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
        {{ $t('cargando_materiales') }}
      </div>

      <!-- Tabla Ecommerce -->
      <div v-if="!cargando && mostrarResultados && tipoVista === 'ecommerce'" class="px-3 pt-2">
        <div class="small text-muted mb-1">
          {{ processedEcommerceRows.length }} / {{ ecommerceRows.length }} {{ $t('filas') }}
        </div>
        <div class="tabla-scroll-fixed tabla-maestro-compacta" ref="tablaEcommerce">
          <table class="table table-bordered table-hover table-sm mb-0">
            <thead class="thead-sticky thead-light">
              <tr>
                <th v-if="rol !== 'cliente'" class="th-ordenable" style="min-width:160px;" @click="ordenarEco('empresa')">
                  <input class="th-search-input" v-model="filterColEco.empresa" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('empresa') }} <i :class="iconoOrdenEco('empresa')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:180px;" @click="ordenarEco('nombreXlsx')">
                  <input class="th-search-input" v-model="filterColEco.nombreXlsx" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('archivo') }} <i :class="iconoOrdenEco('nombreXlsx')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:200px;" @click="ordenarEco('partName')">
                  <input class="th-search-input" v-model="filterColEco.partName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_partName') }} <i :class="iconoOrdenEco('partName')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:120px;" @click="ordenarEco('brandName')">
                  <input class="th-search-input" v-model="filterColEco.brandName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('marca') }} <i :class="iconoOrdenEco('brandName')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:250px;" @click="ordenarEco('detalles')">
                  <input class="th-search-input" v-model="filterColEco.detalles" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_detalles') }} <i :class="iconoOrdenEco('detalles')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:160px;" @click="ordenarEco('categoriaInexlink')">
                  <input class="th-search-input" v-model="filterColEco.categoriaInexlink" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('categoria_inexlink') }} <i :class="iconoOrdenEco('categoriaInexlink')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:80px;" @click="ordenarEco('cantidad')">
                  <input class="th-search-input" v-model="filterColEco.cantidad" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('cantidad') }} <i :class="iconoOrdenEco('cantidad')"></i></span>
                </th>
                <th class="th-ordenable text-center" style="min-width:120px;" @click="ordenarEco('fechaPublicacion')">
                  <input class="th-search-input" v-model="filterColEco.fechaPublicacion" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('fecha_publicacion') }} <i :class="iconoOrdenEco('fechaPublicacion')"></i></span>
                </th>
                <th style="min-width:50px;" class="text-center">{{ $t('link') }}</th>
                <th style="min-width:60px;" class="text-center">{{ $t('detalle') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="processedEcommerceRows.length === 0">
                <td colspan="10" class="text-center text-muted py-3">{{ $t('sin_registros_publicados') }}</td>
              </tr>
              <!-- key por índice: idMaterialETL se repite (un material puede estar en varias fichas) -->
              <tr v-for="(row, idx) in processedEcommerceRows" :key="'eco-' + idx">
                <td v-if="rol !== 'cliente'">{{ row.empresa }}</td>
                <td class="td-truncate" style="max-width:180px;" :title="row.nombreXlsx">{{ row.nombreXlsx }}</td>
                <td class="td-truncate" style="max-width:200px;" :title="row.partName">{{ row.partName }}</td>
                <td class="td-truncate" style="max-width:150px;" :title="row.brandName">{{ row.brandName }}</td>
                <td class="td-truncate" :title="row.detalles">{{ row.detalles }}</td>
                <td class="td-truncate" style="max-width:150px;" :title="row.categoriaInexlink">{{ row.categoriaInexlink }}</td>
                <td class="text-right">{{ row.cantidad }}</td>
                <td class="text-center">{{ row.fechaPublicacion ? new Date(row.fechaPublicacion).toLocaleDateString('es-CL') : '—' }}</td>
                <td class="text-center">
                  <a v-if="row.linkCommerce" :href="row.linkCommerce" target="_blank" rel="noopener noreferrer"
                     style="font-size:1.2rem; text-decoration:none;">🌐</a>
                </td>
                <td class="text-center">
                  <!-- Un Cluster es un solo producto en el ecommerce, pero por dentro trae
                       varios materiales; el detalle es lo que hay detras de ese producto. -->
                  <button v-if="row.tipoFicha === 'C'" class="btn btn-sm btn-outline-primary"
                    @click="abrirDetalleCluster(row)" :title="$t('detalle_cluster')">
                    <i class="fas fa-layer-group"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer flotante -->
        <div class="pagination-floating-bar">
          <div class="d-flex align-items-center">
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ processedEcommerceRows.length }} / {{ ecommerceRows.length }} {{ $t('resultados') }}
            </span>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollEcommerce('left')" :title="$t('scroll_izquierda')"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollEcommerce('right')" :title="$t('scroll_derecha')"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollEcommerce('top')" :title="$t('ir_al_inicio')"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollEcommerce('bottom')" :title="$t('ir_al_final')"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>
      </div>

      <!-- Tabla Inventario -->
      <div v-if="!cargando && mostrarResultados && tipoVista === 'inventario'" class="px-3 pt-2">
        <div class="small text-muted mb-1">
          {{ processedRows.length }} / {{ materialTotal || materialRows.length }} {{ $t('filas') }}
          — {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPagesServer }}
        </div>

        <div class="tabla-scroll-fixed tabla-maestro-compacta" ref="tablaInventario">
          <table class="table table-bordered table-hover table-sm mb-0">
            <thead class="thead-sticky thead-light">
              <tr>
                <th v-if="rol !== 'cliente'" class="th-ordenable" style="min-width:160px;" @click="ordenarPor('nombreEmpresa')">
                  <input class="th-search-input" v-model="filterCol.nombreEmpresa" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_nombreEmpresa') }} <i :class="iconoOrden('nombreEmpresa')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:180px;" @click="ordenarPor('nombreXLSX')">
                  <input class="th-search-input" v-model="filterCol.nombreXLSX" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('archivo') }} <i :class="iconoOrden('nombreXLSX')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:200px;max-width:200px;" @click="ordenarPor('partName')">
                  <input class="th-search-input" v-model="filterCol.partName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_partName') }} <i :class="iconoOrden('partName')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:250px;max-width:250px;" @click="ordenarPor('detalles')">
                  <input class="th-search-input" v-model="filterCol.detalles" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_detalles') }} <i :class="iconoOrden('detalles')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:120px;" @click="ordenarPor('sku')">
                  <input class="th-search-input" v-model="filterCol.sku" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_sku') }} <i :class="iconoOrden('sku')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:130px;" @click="ordenarPor('partNumber')">
                  <input class="th-search-input" v-model="filterCol.partNumber" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_part_number') }} <i :class="iconoOrden('partNumber')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:130px;" @click="ordenarPor('brandName')">
                  <input class="th-search-input" v-model="filterCol.brandName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('fabricante') }} <i :class="iconoOrden('brandName')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:120px;" @click="ordenarPor('modelo')">
                  <input class="th-search-input" v-model="filterCol.modelo" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('modelo') }} <i :class="iconoOrden('modelo')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:130px;" @click="ordenarPor('condicion')">
                  <input class="th-search-input" v-model="filterCol.condicion" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('condicion') }} <i :class="iconoOrden('condicion')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:90px;" @click="ordenarPor('horometro')">
                  <input class="th-search-input" v-model="filterCol.horometro" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_horometro') }} <i :class="iconoOrden('horometro')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:100px;" @click="ordenarPor('anoFabricacion')">
                  <input class="th-search-input" v-model="filterCol.anoFabricacion" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_anoFabricacion') }} <i :class="iconoOrden('anoFabricacion')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:90px;" @click="ordenarPor('odometro')">
                  <input class="th-search-input" v-model="filterCol.odometro" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_odometro') }} <i :class="iconoOrden('odometro')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:140px;" @click="ordenarPor('bodegaUbicacion')">
                  <input class="th-search-input" v-model="filterCol.bodegaUbicacion" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('Warehouse / Location') }} <i :class="iconoOrden('bodegaUbicacion')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:160px;" @click="ordenarPor('categoriaOrigen')">
                  <input class="th-search-input" v-model="filterCol.categoriaOrigen" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_categoriaOrigen') }} <i :class="iconoOrden('categoriaOrigen')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:250px;" @click="ordenarPor('categoria_MM')">
                  <input class="th-search-input" v-model="filterCol.categoria_MM" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_categoria_MM') }} <i :class="iconoOrden('categoria_MM')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:100px;" @click="ordenarPor('precio')">
                  <input class="th-search-input" v-model="filterCol.precio" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('precio') }} <i :class="iconoOrden('precio')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:110px;" @click="ordenarPor('precioVenta')">
                  <input class="th-search-input" v-model="filterCol.precioVenta" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_precioVenta') }} <i :class="iconoOrden('precioVenta')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:80px;" @click="ordenarPor('cantidad')">
                  <input class="th-search-input" v-model="filterCol.cantidad" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('cantidad') }} <i :class="iconoOrden('cantidad')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:100px;" @click="ordenarPor('unidadDeMedida')">
                  <input class="th-search-input" v-model="filterCol.unidadDeMedida" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('unidad_medida') }} <i :class="iconoOrden('unidadDeMedida')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:90px;" @click="ordenarPor('publicado')">
                  <input class="th-search-input" v-model="filterCol.publicado" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_publicado') }} <i :class="iconoOrden('publicado')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:80px;" @click="ordenarPor('vendido')">
                  <input class="th-search-input" v-model="filterCol.vendido" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_vendido') }} <i :class="iconoOrden('vendido')"></i></span>
                </th>
                <th class="th-ordenable text-right" style="min-width:90px;" @click="ordenarPor('cantidadDisponible')">
                  <input class="th-search-input" v-model="filterCol.cantidadDisponible" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('cantidad_disponible') }} <i :class="iconoOrden('cantidadDisponible')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:110px;" @click="ordenarPor('estadoVenta')">
                  <input class="th-search-input" v-model="filterCol.estadoVenta" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_estadoVenta') }} <i :class="iconoOrden('estadoVenta')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:100px;" @click="ordenarPor('fechaVenta')">
                  <input class="th-search-input" v-model="filterCol.fechaVenta" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_fechaVenta') }} <i :class="iconoOrden('fechaVenta')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:120px;" @click="ordenarPor('nombreUsuario')">
                  <input class="th-search-input" v-model="filterCol.nombreUsuario" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_nombreUsuario') }} <i :class="iconoOrden('nombreUsuario')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:90px;" @click="ordenarPor('idMaterialETL')">
                  <input class="th-search-input" v-model="filterCol.idMaterialETL" @click.stop placeholder="" />
                  <span class="th-label">ID <i :class="iconoOrden('idMaterialETL')"></i></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="processedRows.length === 0">
                <td colspan="28" class="text-center text-muted py-3">{{ $t('no_materiales_empresa') }}</td>
              </tr>
              <tr v-for="row in processedRows" :key="row.idMaterialETL || row.sku">
                <td v-if="rol !== 'cliente'">{{ row.nombreEmpresa }}</td>
                <td class="td-truncate" style="max-width:180px;" :title="row.nombreXLSX">{{ row.nombreXLSX }}</td>
                <td class="td-truncate" style="max-width:200px;" :title="row.partName">{{ row.partName }}</td>
                <td class="td-truncate" :title="row.detalles">{{ row.detalles }}</td>
                <td>{{ row.sku }}</td>
                <td class="td-truncate" style="max-width:180px;" :title="row.partNumber">{{ row.partNumber }}</td>
                <td class="td-truncate" style="max-width:150px;" :title="row.brandName">{{ row.brandName }}</td>
                <td class="td-truncate" style="max-width:150px;" :title="row.modelo">{{ row.modelo }}</td>
                <td>{{ row.condicion }}</td>
                <td class="text-right">{{ formatCellNumber(row.horometro) }}</td>
                <td class="text-right">{{ formatCellNumber(row.anoFabricacion) }}</td>
                <td class="text-right">{{ formatCellNumber(row.odometro) }}</td>
                <td>{{ row.bodegaUbicacion }}</td>
                <td>{{ row.categoriaOrigen }}</td>
                <td>{{ row.categoria_MM }}</td>
                <td class="text-right">{{ formatCellNumber(row.precio, 'money') }}</td>
                <td class="text-right">{{ formatCellNumber(row.precioVenta, 'money') }}</td>
                <td class="text-right">{{ formatCellNumber(row.cantidad) }}</td>
                <td>{{ row.unidadDeMedida }}</td>
                <td class="text-center">
                  <span class="badge" :class="row.publicadoFlag ? 'badge-success' : 'badge-warning text-dark'">
                    {{ row.publicado }}
                  </span>
                </td>
                <td>{{ row.vendido === true ? 'Sí' : row.vendido === false ? 'No' : '' }}</td>
                <td class="text-right">{{ formatCellNumber(row.cantidadDisponible) }}</td>
                <td>{{ row.estadoVenta }}</td>
                <td>{{ row.fechaVenta ? new Date(row.fechaVenta).toLocaleDateString('es-CL') : '' }}</td>
                <td>{{ row.nombreUsuario }}</td>
                <td>{{ row.idMaterialETL }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Footer flotante -->
        <div class="pagination-floating-bar">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
            <select v-model.number="pageSize" @change="onPageSizeChange(pageSize)" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="200">200</option>
              <option :value="999999">Todas</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="currentPage === 1" @click="onPageChange(currentPage - 1)">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') }} {{ currentPage }} {{ $t('de') }} {{ totalPagesServer }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ materialTotal || materialRows.length }} {{ $t('resultados') }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="currentPage >= totalPagesServer" @click="onPageChange(currentPage + 1)">
              {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('left')" :title="$t('scroll_izquierda')"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('right')" :title="$t('scroll_derecha')"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('top')" :title="$t('ir_al_inicio')"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollTabla('bottom')" :title="$t('ir_al_final')"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>
      </div>

      <!-- Tabla Maestro Materiales -->
      <div v-if="!cargando && mostrarResultados && tipoVista === 'maestro_materiales'" class="px-3 pt-2">
        <div class="small text-muted mb-1">
          {{ processedMaestroRows.length }} / {{ maestroTotal || maestroRows.length }} {{ $t('filas') }}
          — {{ $t('pagina') }} {{ maestroCurrentPage }} {{ $t('de') }} {{ totalPagesMaestro }}
        </div>
        <div class="tabla-scroll-fixed tabla-maestro-compacta" ref="tablaMaestro">
          <table class="table table-bordered table-hover table-sm mb-0">
            <thead class="thead-sticky thead-light">
              <tr>
                <th style="width:40px;"></th>
                <th class="th-ordenable" style="min-width:85px;" @click="ordenarMaestro('skuInexlink')">
                  <input class="th-search-input" v-model="filterColMaestro.skuInexlink" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_sku_inexlink') }} <i :class="iconoOrdenMaestro('skuInexlink')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:140px;" @click="ordenarMaestro('partName')">
                  <input class="th-search-input" v-model="filterColMaestro.partName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_partName') }} <i :class="iconoOrdenMaestro('partName')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:180px;" @click="ordenarMaestro('detalles')">
                  <input class="th-search-input" v-model="filterColMaestro.detalles" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_detalles') }} <i :class="iconoOrdenMaestro('detalles')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:220px;" @click="ordenarMaestro('categoria')">
                  <button v-if="puedeEscribir" class="btn btn-info btn-sm shadow-sm mb-1 btn-modificar-categoria" @click.stop="abrirMaestroCategoriaModal">
                    <i class="fas fa-list me-1"></i> {{ $t('modificar_categoria') }}
                  </button>
                  <input class="th-search-input" v-model="filterColMaestro.categoria" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_categoria') }} <i :class="iconoOrdenMaestro('categoria')"></i></span>
                </th>
                <th class="text-center" style="width:35px;">
                  <input type="checkbox" :disabled="!puedeEscribir" :checked="maestroCategoriaAllChecked" @change="toggleAllChecksMaestroCategoria($event.target.checked)" />
                </th>
                <th class="th-ordenable" style="min-width:100px;" @click="ordenarMaestro('brandName')">
                  <button v-if="puedeEscribir" class="btn btn-info btn-sm shadow-sm mb-1 btn-modificar-categoria" @click.stop="showMaestroBrandNameModal = true">
                    <i class="fas fa-list me-1"></i> {{ $t('modificar_fabricante') }}
                  </button>
                  <input class="th-search-input" v-model="filterColMaestro.brandName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('fabricante') }} <i :class="iconoOrdenMaestro('brandName')"></i></span>
                </th>
                <th class="text-center" style="width:35px;">
                  <input type="checkbox" :disabled="!puedeEscribir" :checked="maestroBrandNameAllChecked" @change="toggleAllChecksMaestroBrandName($event.target.checked)" />
                </th>
                <th class="th-ordenable" style="min-width:110px;" @click="ordenarMaestro('partNumber')">
                  <input class="th-search-input" v-model="filterColMaestro.partNumber" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_part_number') }} <i :class="iconoOrdenMaestro('partNumber')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:110px;" @click="ordenarMaestro('modelo')">
                  <input class="th-search-input" v-model="filterColMaestro.modelo" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('modelo') }} <i :class="iconoOrdenMaestro('modelo')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:100px;" @click="ordenarMaestro('segmento')">
                  <input class="th-search-input" v-model="filterColMaestro.segmento" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('segmento') }} <i :class="iconoOrdenMaestro('segmento')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:100px;" @click="ordenarMaestro('familia')">
                  <input class="th-search-input" v-model="filterColMaestro.familia" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('familia') }} <i :class="iconoOrdenMaestro('familia')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:100px;" @click="ordenarMaestro('clase')">
                  <input class="th-search-input" v-model="filterColMaestro.clase" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('clase') }} <i :class="iconoOrdenMaestro('clase')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:130px;" @click="ordenarMaestro('token')">
                  <input class="th-search-input" v-model="filterColMaestro.token" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('token') }} <i :class="iconoOrdenMaestro('token')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:65px;" @click="ordenarMaestro('idOrigen')">
                  <input class="th-search-input" v-model="filterColMaestro.idOrigen" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_id_origen') }} <i :class="iconoOrdenMaestro('idOrigen')"></i></span>
                </th>
                <th class="th-ordenable text-center" style="min-width:95px;" @click="ordenarMaestro('fechaIntegracion')">
                  <input class="th-search-input" v-model="filterColMaestro.fechaIntegracion" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_fecha_integracion') }} <i :class="iconoOrdenMaestro('fechaIntegracion')"></i></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="processedMaestroRows.length === 0">
                <td colspan="16" class="text-center text-muted py-3">{{ $t('no_materiales_empresa') }}</td>
              </tr>
              <tr v-for="row in processedMaestroRows" :key="row.id" :class="{ 'fila-modificada': row._dirty }">
                <td class="text-center">
                  <button v-if="puedeEscribir"
                    class="btn btn-sm btn-success"
                    :class="{ 'btn-pulse': row._dirty && !row._saving }"
                    :disabled="!row._dirty || row._saving"
                    @click="guardarMaestroRow(row)"
                    :title="$t('guardar')">
                    <span v-if="row._saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <i v-else class="fas fa-save"></i>
                  </button>
                </td>
                <td>{{ row.skuInexlink }}</td>
                <td style="min-width:140px;">
                  <input v-model="row.partName" @input="marcarDirtyMaestro(row)" :readonly="!puedeEscribir" :title="row.partName" class="form-control form-control-sm" />
                </td>
                <td style="min-width:180px;">
                  <input v-model="row.detalles" @input="marcarDirtyMaestro(row)" :readonly="!puedeEscribir" :title="row.detalles" class="form-control form-control-sm" />
                </td>
                <td style="min-width:220px;" :title="row.categoria">
                  <el-select v-model="row.categoria" filterable clearable size="small" :disabled="!puedeEscribir" :placeholder="$t('seleccione')"
                    @change="onMaestroCategoriaChange(row)" style="width:100%;">
                    <el-option v-for="cat in maestroCategoriaOptions" :key="cat" :label="cat" :value="cat" />
                  </el-select>
                </td>
                <td class="text-center">
                  <input type="checkbox" :disabled="!puedeEscribir" v-model="checkedIdsMaestroCategoria" :value="row.id" />
                </td>
                <td>
                  <input v-model="row.brandName" @input="marcarDirtyMaestro(row)" :readonly="!puedeEscribir" :title="row.brandName" class="form-control form-control-sm" />
                </td>
                <td class="text-center">
                  <input type="checkbox" :disabled="!puedeEscribir" v-model="checkedIdsMaestroBrandName" :value="row.id" />
                </td>
                <td>
                  <input v-model="row.partNumber" @input="marcarDirtyMaestro(row)" :readonly="!puedeEscribir" :title="row.partNumber" class="form-control form-control-sm" />
                </td>
                <td>
                  <input v-model="row.modelo" @input="marcarDirtyMaestro(row)" :readonly="!puedeEscribir" :title="row.modelo" class="form-control form-control-sm" />
                </td>
                <td>{{ row.segmento }}</td>
                <td>{{ row.familia }}</td>
                <td>{{ row.clase }}</td>
                <td class="text-monospace small" :title="row.token">{{ row.token }}</td>
                <td>{{ row.idOrigen }}</td>
                <td class="text-center">{{ row.fechaIntegracion }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Footer flotante -->
        <div class="pagination-floating-bar">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
            <select v-model.number="maestroPageSize" @change="onMaestroPageSizeChange(maestroPageSize)" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="200">200</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="maestroCurrentPage === 1" @click="onMaestroPageChange(maestroCurrentPage - 1)">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') }} {{ maestroCurrentPage }} {{ $t('de') }} {{ totalPagesMaestro }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ maestroTotal || maestroRows.length }} {{ $t('resultados') }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="maestroCurrentPage >= totalPagesMaestro" @click="onMaestroPageChange(maestroCurrentPage + 1)">
              {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollMaestro('left')" :title="$t('scroll_izquierda')"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollMaestro('right')" :title="$t('scroll_derecha')"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollMaestro('top')" :title="$t('ir_al_inicio')"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollMaestro('bottom')" :title="$t('ir_al_final')"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>
      </div>

      <!-- Tabla Pre Maestro Materiales -->
      <div v-if="!cargando && mostrarResultados && tipoVista === 'pre_maestro_materiales'" class="px-3 pt-2">
        <div class="small text-muted mb-1">
          {{ processedPreMaestroRows.length }} / {{ preMaestroTotal || preMaestroRows.length }} {{ $t('filas') }}
          — {{ $t('pagina') }} {{ preMaestroCurrentPage }} {{ $t('de') }} {{ totalPagesPreMaestro }}
        </div>
        <div class="tabla-scroll-fixed tabla-maestro-compacta" ref="tablaPreMaestro">
          <table class="table table-bordered table-hover table-sm mb-0">
            <thead class="thead-sticky thead-light">
              <tr>
                <th v-if="mostrarSeleccionPreMaestro" class="text-center" style="width:60px;">
                  <input type="checkbox" :disabled="!puedeEscribir" :checked="preMaestroAllChecked" @change="togglePreMaestroSelectAll($event.target.checked)" :title="$t('marcar_desmarcar_todos')" />
                  <div class="th-label" style="font-weight:600;">{{ $t('todos') }}</div>
                </th>
                <th style="width:90px;"></th>
                <th class="th-ordenable" style="min-width:95px;" @click="ordenarPreMaestro('skuInexlink')">
                  <input class="th-search-input" v-model="filterColPreMaestro.skuInexlink" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_sku_inexlink') }} <i :class="iconoOrdenPreMaestro('skuInexlink')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:140px;" @click="ordenarPreMaestro('partName')">
                  <input class="th-search-input" v-model="filterColPreMaestro.partName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_partName') }} <i :class="iconoOrdenPreMaestro('partName')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:180px;" @click="ordenarPreMaestro('detalles')">
                  <input class="th-search-input" v-model="filterColPreMaestro.detalles" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_detalles') }} <i :class="iconoOrdenPreMaestro('detalles')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:120px;" @click="ordenarPreMaestro('categoriaInexlink')">
                  <button v-if="puedeEscribir && mostrarSeleccionPreMaestro" class="btn btn-info btn-sm shadow-sm mb-1 btn-modificar-categoria" @click.stop="abrirPreMaestroCategoriaModal">
                    <i class="fas fa-list me-1"></i> {{ $t('modificar_categoria') }}
                  </button>
                  <input class="th-search-input" v-model="filterColPreMaestro.categoriaInexlink" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_categoria_inexlink') }} <i :class="iconoOrdenPreMaestro('categoriaInexlink')"></i></span>
                </th>
                <th v-if="mostrarSeleccionPreMaestro" class="text-center" style="width:35px;">
                  <input type="checkbox" :disabled="!puedeEscribir" :checked="preMaestroCategoriaAllChecked" @change="toggleAllChecksPreMaestroCategoria($event.target.checked)" />
                </th>
                <th class="th-ordenable" style="min-width:100px;" @click="ordenarPreMaestro('brandName')">
                  <button v-if="puedeEscribir && mostrarSeleccionPreMaestro" class="btn btn-info btn-sm shadow-sm mb-1 btn-modificar-categoria" @click.stop="showPreMaestroBrandNameModal = true">
                    <i class="fas fa-list me-1"></i> {{ $t('modificar_fabricante') }}
                  </button>
                  <input class="th-search-input" v-model="filterColPreMaestro.brandName" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('fabricante') }} <i :class="iconoOrdenPreMaestro('brandName')"></i></span>
                </th>
                <th v-if="mostrarSeleccionPreMaestro" class="text-center" style="width:35px;">
                  <input type="checkbox" :disabled="!puedeEscribir" :checked="preMaestroBrandNameAllChecked" @change="toggleAllChecksPreMaestroBrandName($event.target.checked)" />
                </th>
                <th class="th-ordenable" style="min-width:110px;" @click="ordenarPreMaestro('partNumber')">
                  <input class="th-search-input" v-model="filterColPreMaestro.partNumber" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_part_number') }} <i :class="iconoOrdenPreMaestro('partNumber')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:110px;" @click="ordenarPreMaestro('modelo')">
                  <input class="th-search-input" v-model="filterColPreMaestro.modelo" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('modelo') }} <i :class="iconoOrdenPreMaestro('modelo')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:130px;" @click="ordenarPreMaestro('token')">
                  <input class="th-search-input" v-model="filterColPreMaestro.token" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('token') }} <i :class="iconoOrdenPreMaestro('token')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:95px;" @click="ordenarPreMaestro('estado')">
                  <input class="th-search-input" v-model="filterColPreMaestro.estado" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('estado') }} <i :class="iconoOrdenPreMaestro('estado')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:95px;" @click="ordenarPreMaestro('fechaCarga')">
                  <input class="th-search-input" v-model="filterColPreMaestro.fechaCarga" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_fecha_carga') }} <i :class="iconoOrdenPreMaestro('fechaCarga')"></i></span>
                </th>
                <th class="th-ordenable" style="min-width:95px;" @click="ordenarPreMaestro('fechaIntegracion')">
                  <input class="th-search-input" v-model="filterColPreMaestro.fechaIntegracion" @click.stop placeholder="" />
                  <span class="th-label">{{ $t('col_fecha_integracion') }} <i :class="iconoOrdenPreMaestro('fechaIntegracion')"></i></span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="processedPreMaestroRows.length === 0">
                <td :colspan="mostrarSeleccionPreMaestro ? 15 : 12" class="text-center text-muted py-3">{{ $t('no_materiales_empresa') }}</td>
              </tr>
              <tr v-for="row in processedPreMaestroRows" :key="row.id">
                <td v-if="mostrarSeleccionPreMaestro" class="text-center">
                  <!-- En "Todos" conviven pendientes e integrados: lo ya integrado no se vuelve a integrar. -->
                  <input v-if="!row.integrado" type="checkbox" :disabled="!puedeEscribir" v-model="preMaestroSelectedIds" :value="row.id" />
                </td>
                <td class="text-center">
                  <!-- Un material integrado ya tiene copia en el Maestro: editarlo aca dejaria las
                       dos versiones distintas, asi que tampoco se edita. -->
                  <button v-if="puedeEscribir && !row.integrado" class="btn btn-sm btn-outline-primary"
                    @click="abrirEditarPreMaestro(row)" :title="$t('editar')">
                    <i class="fas fa-pencil-alt"></i>
                  </button>
                  <!-- Un material integrado ya dejó copia en el Maestro: su fila es el registro de
                       dónde salió, así que no se elimina. -->
                  <button v-if="puedeEscribir && !row.integrado" class="btn btn-sm btn-outline-danger ml-1"
                    :disabled="eliminandoPreMaestroId === row.id"
                    @click="eliminarPreMaestro(row)" :title="$t('eliminar')">
                    <span v-if="eliminandoPreMaestroId === row.id" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <i v-else class="fas fa-trash-alt"></i>
                  </button>
                </td>
                <td>{{ row.skuInexlink }}</td>
                <td class="td-truncate" style="max-width:200px;" :title="row.partName">{{ row.partName }}</td>
                <td class="td-truncate" :title="row.detalles">{{ row.detalles }}</td>
                <td class="td-truncate" style="max-width:150px;" :title="row.categoriaInexlink">{{ row.categoriaInexlink }}</td>
                <td v-if="mostrarSeleccionPreMaestro" class="text-center">
                  <input v-if="!row.integrado" type="checkbox" :disabled="!puedeEscribir" v-model="checkedIdsPreMaestroCategoria" :value="row.id" />
                </td>
                <td class="td-truncate" style="max-width:150px;" :title="row.brandName">{{ row.brandName }}</td>
                <td v-if="mostrarSeleccionPreMaestro" class="text-center">
                  <input v-if="!row.integrado" type="checkbox" :disabled="!puedeEscribir" v-model="checkedIdsPreMaestroBrandName" :value="row.id" />
                </td>
                <td class="td-truncate" style="max-width:180px;" :title="row.partNumber">{{ row.partNumber }}</td>
                <td class="td-truncate" style="max-width:150px;" :title="row.modelo">{{ row.modelo }}</td>
                <td class="text-monospace small" :title="row.token">{{ row.token }}</td>
                <td>
                  <!-- Pendiente en amarillo con texto negro: el gris se perdia contra la fila. -->
                  <span class="badge" :class="row.integrado ? 'badge-success' : 'badge-warning text-dark'">{{ row.estado }}</span>
                </td>
                <td>{{ row.fechaCarga }}</td>
                <td>{{ row.fechaIntegracion }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Footer flotante -->
        <div class="pagination-floating-bar">
          <div class="d-flex align-items-center">
            <label class="mr-2 mb-0 text-secondary" style="font-size:.85rem;">{{ $t('items_por_pagina') }}</label>
            <select v-model.number="preMaestroPageSize" @change="onPreMaestroPageSizeChange(preMaestroPageSize)" class="form-control form-control-sm" style="width:70px;">
              <option :value="20">20</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="200">200</option>
            </select>
          </div>
          <div class="d-flex align-items-center" style="gap:12px;">
            <button class="btn btn-outline-secondary btn-sm" :disabled="preMaestroCurrentPage === 1" @click="onPreMaestroPageChange(preMaestroCurrentPage - 1)">
              <i class="fas fa-arrow-left mr-1"></i> {{ $t('anterior') }}
            </button>
            <span style="font-weight:600;color:#6c757d;font-size:.9rem;">
              {{ $t('pagina') }} {{ preMaestroCurrentPage }} {{ $t('de') }} {{ totalPagesPreMaestro }}
              <span class="text-muted ml-2" style="font-size:.8rem;">({{ preMaestroTotal || preMaestroRows.length }} {{ $t('resultados') }})</span>
            </span>
            <button class="btn btn-outline-primary btn-sm" :disabled="preMaestroCurrentPage >= totalPagesPreMaestro" @click="onPreMaestroPageChange(preMaestroCurrentPage + 1)">
              {{ $t('siguiente') }} <i class="fas fa-arrow-right ml-1"></i>
            </button>
          </div>
          <div class="d-flex align-items-center" style="gap:6px;">
            <button class="btn btn-sm btn-scroll-nav" @click="scrollPreMaestro('left')" :title="$t('scroll_izquierda')"><i class="fas fa-chevron-left"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollPreMaestro('right')" :title="$t('scroll_derecha')"><i class="fas fa-chevron-right"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollPreMaestro('top')" :title="$t('ir_al_inicio')"><i class="fas fa-chevron-up"></i></button>
            <button class="btn btn-sm btn-scroll-nav" @click="scrollPreMaestro('bottom')" :title="$t('ir_al_final')"><i class="fas fa-chevron-down"></i></button>
          </div>
        </div>
      </div>

      <!-- Modal Detalle del Cluster: los materiales detras de un producto tipo C -->
      <b-modal v-model="modalDetalleCluster" size="xl" ok-only :ok-title="$t('cerrar')" no-enforce-focus
        :title="detalleClusterTitulo">
        <div v-if="detalleClusterLoading" class="text-center py-4">
          <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
        </div>
        <div v-else>
          <div v-if="!detalleClusterRows.length" class="text-center text-muted py-4">
            {{ $t('sin_registros_publicados') }}
          </div>
          <div v-else>
            <div class="small text-muted mb-2">
              {{ processedDetalleClusterRows.length }} / {{ detalleClusterRows.length }} {{ $t('filas') }}
            </div>
            <div class="table-responsive" style="max-height:60vh;overflow-y:auto;">
              <table class="table table-sm table-bordered mb-0">
                <thead class="thead-light">
                  <tr>
                    <th class="th-ordenable" style="min-width:140px;" @click="ordenarDetalleCluster('partName')">
                      <input class="th-search-input" v-model="filterColDetalleCluster.partName" @click.stop placeholder="" />
                      <span class="th-label">{{ $t('col_partName') }} <i :class="iconoOrdenDetalleCluster('partName')"></i></span>
                    </th>
                    <th class="th-ordenable" style="min-width:110px;" @click="ordenarDetalleCluster('brandName')">
                      <input class="th-search-input" v-model="filterColDetalleCluster.brandName" @click.stop placeholder="" />
                      <span class="th-label">{{ $t('marca') }} <i :class="iconoOrdenDetalleCluster('brandName')"></i></span>
                    </th>
                    <th class="th-ordenable" style="min-width:150px;" @click="ordenarDetalleCluster('detalles')">
                      <input class="th-search-input" v-model="filterColDetalleCluster.detalles" @click.stop placeholder="" />
                      <span class="th-label">{{ $t('col_detalles') }} <i :class="iconoOrdenDetalleCluster('detalles')"></i></span>
                    </th>
                    <th class="th-ordenable" style="min-width:130px;" @click="ordenarDetalleCluster('categoriaInexlink')">
                      <input class="th-search-input" v-model="filterColDetalleCluster.categoriaInexlink" @click.stop placeholder="" />
                      <span class="th-label">{{ $t('categoria_inexlink') }} <i :class="iconoOrdenDetalleCluster('categoriaInexlink')"></i></span>
                    </th>
                    <th class="th-ordenable text-right" style="min-width:90px;" @click="ordenarDetalleCluster('cantidad')">
                      <input class="th-search-input" v-model="filterColDetalleCluster.cantidad" @click.stop placeholder="" />
                      <span class="th-label">{{ $t('cantidad') }} <i :class="iconoOrdenDetalleCluster('cantidad')"></i></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(d, i) in processedDetalleClusterRows" :key="i">
                    <td class="td-truncate" style="max-width:200px;" :title="d.partName">{{ d.partName }}</td>
                    <td class="td-truncate" style="max-width:150px;" :title="d.brandName">{{ d.brandName }}</td>
                    <td class="td-truncate" :title="d.detalles">{{ d.detalles }}</td>
                    <td class="td-truncate" style="max-width:150px;" :title="d.categoriaInexlink">{{ d.categoriaInexlink }}</td>
                    <td class="text-right">{{ d.cantidad }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- Modal Resultado de la Importacion -->
      <b-modal v-model="modalImportPreMaestro" :title="$t('importar_excel')" size="lg" ok-only
        :ok-title="$t('cerrar')" no-enforce-focus>
        <div v-if="importResultado">
          <b-alert v-if="importResultado.errores && importResultado.errores.length" show variant="danger" class="mb-3">
            <strong>{{ $t('import_no_realizada') }}</strong>
            <div class="small mt-1">
              {{ $t('import_filas_con_error').replace('{n}', importResultado.errores.length).replace('{total}', importResultado.leidos) }}
            </div>
          </b-alert>
          <b-alert v-else show variant="success" class="mb-3">
            <strong>{{ $t('import_ok').replace('{n}', importResultado.insertados) }}</strong>
          </b-alert>

          <div v-if="importResultado.errores && importResultado.errores.length"
            class="table-responsive" style="max-height:340px;overflow-y:auto;">
            <table class="table table-sm table-bordered mb-0">
              <thead class="thead-light">
                <tr>
                  <th style="width:80px;">{{ $t('fila') }}</th>
                  <th style="width:180px;">{{ $t('campo') }}</th>
                  <th>{{ $t('detalle') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(e, i) in importResultado.errores" :key="i">
                  <td class="text-center">{{ e.fila }}</td>
                  <td>{{ e.campo }}</td>
                  <td>{{ e.mensaje }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-modal>

      <!-- Modal Resultado del proceso contra el inventario -->
      <b-modal v-model="modalValidarPreMaestro" :title="$t('validar_e_ingresar')" size="lg" ok-only
        :ok-title="$t('cerrar')" no-enforce-focus>
        <div v-if="validarResultado">
          <b-alert v-if="validarResultado.insertados > 0" show variant="success" class="mb-3">
            <strong>{{ $t('validar_ok').replace('{n}', validarResultado.insertados) }}</strong>
            <div v-if="validarResultado.skuDesde" class="small mt-1">
              {{ $t('validar_sku_rango')
                   .replace('{desde}', validarResultado.skuDesde)
                   .replace('{hasta}', validarResultado.skuHasta) }}
            </div>
          </b-alert>
          <b-alert v-else show variant="warning" class="mb-3">
            <strong>{{ $t('validar_sin_ingresos') }}</strong>
          </b-alert>

          <div class="small text-muted mb-1">
            {{ $t('validar_resumen')
                 .replace('{leidos}', validarResultado.leidos)
                 .replace('{insertados}', validarResultado.insertados)
                 .replace('{descartados}', validarResultado.descartados) }}
          </div>

          <!-- Lo que quedo sin marcar vuelve a entrar solo cuando se corrija el material -->
          <div class="small text-muted mb-3">
            {{ $t('validar_marcados')
                 .replace('{marcados}', validarResultado.marcados)
                 .replace('{pendientes}', validarResultado.pendientes) }}
          </div>

          <!-- Resumen por motivo: el archivo se entiende de un vistazo, sin leer fila por fila -->
          <table v-if="validarResultado.resumen && validarResultado.resumen.length"
            class="table table-sm table-bordered mb-3">
            <thead class="thead-light">
              <tr>
                <th>{{ $t('motivo') }}</th>
                <th style="width:100px;" class="text-center">{{ $t('cantidad_filas') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, i) in validarResultado.resumen" :key="i">
                <td>{{ etiquetaMotivoDescarte(r.motivo) }}</td>
                <td class="text-center">{{ r.filas }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="validarResultado.ingresados && validarResultado.ingresados.length">
            <div class="small font-weight-bold mb-1">
              {{ $t('validar_muestra_ingresados')
                   .replace('{n}', validarResultado.ingresados.length)
                   .replace('{total}', validarResultado.insertados) }}
            </div>
            <div class="table-responsive mb-3" style="max-height:260px;overflow-y:auto;">
              <table class="table table-sm table-bordered mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="width:110px;">{{ $t('col_sku_inexlink') }}</th>
                    <th>{{ $t('fabricante') }}</th>
                    <th>{{ $t('col_part_number') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(f, i) in validarResultado.ingresados" :key="i">
                    <td>{{ f.skuInexlink }}</td>
                    <td class="td-truncate" style="max-width:220px;" :title="f.brandName">{{ f.brandName }}</td>
                    <td class="td-truncate" style="max-width:220px;" :title="f.partNumber">{{ f.partNumber }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div v-if="validarResultado.descartes && validarResultado.descartes.length">
            <div class="small font-weight-bold mb-1">
              {{ $t('validar_muestra_descartes')
                   .replace('{n}', validarResultado.descartes.length)
                   .replace('{total}', validarResultado.descartados) }}
            </div>
            <div class="table-responsive" style="max-height:260px;overflow-y:auto;">
              <table class="table table-sm table-bordered mb-0">
                <thead class="thead-light">
                  <tr>
                    <th style="width:90px;">ID ETL</th>
                    <th>{{ $t('fabricante') }}</th>
                    <th>{{ $t('col_part_number') }}</th>
                    <th style="width:200px;">{{ $t('motivo') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(f, i) in validarResultado.descartes" :key="i">
                    <td class="text-center">{{ f.idMaterialETL }}</td>
                    <td class="td-truncate" style="max-width:200px;" :title="f.brandName">{{ f.brandName }}</td>
                    <td class="td-truncate" style="max-width:200px;" :title="f.partNumber">{{ f.partNumber }}</td>
                    <td>{{ etiquetaMotivoDescarte(f.motivo) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-modal>

      <!-- Modal Nuevo Registro Pre Maestro Materiales -->
      <b-modal
        v-model="modalNuevoPreMaestro"
        :title="`${preMaestroEditandoId ? $t('editar') : $t('nuevo')} - ${$t('pre_maestro_materiales')}`"
        size="lg"
        no-enforce-focus
        @hidden="resetNuevoPreMaestro"
      >
        <div class="row">
          <div class="col-md-6">
            <!-- Solo informativa: la fecha de carga la fija el sistema al crear el registro. -->
            <b-form-group :label="$t('col_fecha_carga')">
              <b-form-input :value="nuevoPreMaestro.fechaCarga || $t('asignada_por_el_sistema')" disabled />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group :label="$t('col_partName')">
              <b-form-input v-model="nuevoPreMaestro.partName" :placeholder="$t('col_partName')" />
            </b-form-group>
          </div>
          <div class="col-md-12">
            <b-form-group :label="$t('col_detalles')">
              <b-form-textarea v-model="nuevoPreMaestro.detalles" :placeholder="$t('col_detalles')" rows="2" max-rows="4" />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <!-- Selector con busqueda sobre la taxonomia Inexlink: escrita a mano, una categoria
                 que no existe deja el material sin clase, segmento ni familia al integrarlo. -->
            <b-form-group :label="$t('col_categoria_inexlink')">
              <el-select v-model="nuevoPreMaestro.categoriaInexlink" filterable clearable
                :placeholder="$t('seleccione')" :loading="cargandoTaxonomias" style="width:100%;">
                <el-option v-for="cat in maestroCategoriaOptions" :key="cat" :label="cat" :value="cat" />
              </el-select>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group :label="$t('fabricante')">
              <b-form-input v-model="nuevoPreMaestro.brandName" :placeholder="$t('fabricante')" />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group :label="$t('col_part_number')">
              <b-form-input v-model="nuevoPreMaestro.partNumber" :placeholder="$t('col_part_number')" />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group :label="$t('modelo')">
              <b-form-input v-model="nuevoPreMaestro.modelo" :placeholder="$t('modelo')" />
            </b-form-group>
          </div>
        </div>

        <b-alert variant="danger" :show="!!errorNuevoPreMaestro" dismissible @dismissed="errorNuevoPreMaestro = ''">
          {{ errorNuevoPreMaestro }}
        </b-alert>

        <template #modal-footer>
          <b-button variant="secondary" @click="modalNuevoPreMaestro = false">{{ $t('cancelar') }}</b-button>
          <b-button v-if="puedeEscribir"
            variant="primary"
            :disabled="guardandoPreMaestro"
            @click="guardarNuevoPreMaestro"
          >
            <b-spinner small v-if="guardandoPreMaestro" class="mr-1" />
            {{ $t('guardar') }}
          </b-button>
        </template>
      </b-modal>

      <!-- Modal actualizacion masiva: Categoria Inexlink en Pre Maestro Materiales -->
      <b-modal v-model="showPreMaestroCategoriaModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>
          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') }}</label>
          <b-form-radio-group v-model="preMaestroCategoriaApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_pendientes') }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nueva_categoria') }}</label>
          <el-select v-model="selectedPreMaestroCategoria" filterable clearable :placeholder="$t('seleccione')" :loading="cargandoTaxonomias" style="width: 100%;">
            <el-option v-for="cat in maestroCategoriaOptions" :key="cat" :label="cat" :value="cat" />
          </el-select>

          <div v-if="preMaestroCategoriaApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos_pre_maestro_generico') }}
          </div>

          <button v-if="puedeEscribir" class="btn btn-primary mt-3" @click="aplicarPreMaestroCategoriaSeleccionada" :disabled="isBulkApplyingPreMaestro || !selectedPreMaestroCategoria">
            {{ $t('modal_aplicar_categoria') }}
          </button>
        </div>
      </b-modal>

      <!-- Modal actualizacion masiva: Fabricante en Pre Maestro Materiales -->
      <b-modal v-model="showPreMaestroBrandNameModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>
          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') }}</label>
          <b-form-radio-group v-model="preMaestroBrandNameApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_pendientes') }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nuevo_fabricante') }}</label>
          <input v-model.trim="selectedPreMaestroBrandName" type="text" class="form-control"
            :placeholder="$t('escriba_fabricante')" maxlength="150" @keyup.enter="aplicarPreMaestroBrandNameSeleccionada" />

          <div v-if="!selectedPreMaestroBrandName" class="text-muted small mt-2">
            <i class="fas fa-info-circle me-1"></i>
            {{ $t('aviso_fabricante_vacio') }}
          </div>

          <div v-if="preMaestroBrandNameApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos_pre_maestro_generico') }}
          </div>

          <button v-if="puedeEscribir" class="btn btn-primary mt-3" @click="aplicarPreMaestroBrandNameSeleccionada" :disabled="isBulkApplyingPreMaestro">
            {{ $t('modal_aplicar_fabricante') }}
          </button>
        </div>
      </b-modal>

      <!-- Modal actualizacion masiva: Categoria en Maestro Materiales -->
      <b-modal v-model="showMaestroCategoriaModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>
          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') }}</label>
          <b-form-radio-group v-model="maestroCategoriaApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_resultados') }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nueva_categoria') }}</label>
          <el-select v-model="selectedMaestroCategoria" filterable clearable :placeholder="$t('seleccione')" :loading="cargandoTaxonomias" style="width: 100%;">
            <el-option v-for="cat in maestroCategoriaOptions" :key="cat" :label="cat" :value="cat" />
          </el-select>

          <div v-if="maestroCategoriaApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos_maestro_generico') }}
          </div>

          <button v-if="puedeEscribir" class="btn btn-primary mt-3" @click="aplicarMaestroCategoriaSeleccionada" :disabled="isBulkApplyingMaestro || !selectedMaestroCategoria">
            {{ $t('modal_aplicar_categoria') }}
          </button>
        </div>
      </b-modal>

      <!-- Modal actualizacion masiva: Fabricante en Maestro Materiales -->
      <b-modal v-model="showMaestroBrandNameModal" :title="$t('productos_seleccionados_modificar')" hide-footer>
        <div>
          <label class="fw-bold mb-1 d-block">{{ $t('aplicar_a') }}</label>
          <b-form-radio-group v-model="maestroBrandNameApplyScope" class="mb-3" stacked>
            <b-form-radio value="selected">{{ $t('aplicar_seleccionados') }}</b-form-radio>
            <b-form-radio value="all">{{ $t('aplicar_todos_resultados') }}</b-form-radio>
          </b-form-radio-group>

          <label class="fw-bold">{{ $t('modal_nuevo_fabricante') }}</label>
          <input v-model.trim="selectedMaestroBrandName" type="text" class="form-control"
            :placeholder="$t('escriba_fabricante')" maxlength="150" @keyup.enter="aplicarMaestroBrandNameSeleccionada" />

          <div v-if="!selectedMaestroBrandName" class="text-muted small mt-2">
            <i class="fas fa-info-circle me-1"></i>
            {{ $t('aviso_fabricante_vacio') }}
          </div>

          <div v-if="maestroBrandNameApplyScope === 'all'" class="text-danger small mt-2">
            <i class="fas fa-exclamation-triangle me-1"></i>
            {{ $t('aviso_aplicar_todos_maestro_generico') }}
          </div>

          <button v-if="puedeEscribir" class="btn btn-primary mt-3" @click="aplicarMaestroBrandNameSeleccionada" :disabled="isBulkApplyingMaestro">
            {{ $t('modal_aplicar_fabricante') }}
          </button>
        </div>
      </b-modal>

    </b-container>
  </div>
</template>

<script>
import { Select, Option, DatePicker } from 'element-ui'
import empresaService from '@/api/empresaService'
import materialService from '@/api/materialService'
import utilsService from '@/api/utilsService'
import * as XLSX from 'xlsx'
import Swal from 'sweetalert2'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 2500,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

export default {
  name: 'Inventario',
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      lang: localStorage.getItem('language') || 'es',
      // Empresas
      empresas: [],
      empresaSeleccionada: 0,

      // Datos tabla
      materialRows: [],
      materialTotal: null,

      // Columnas
      columns: [
        { key: 'nombreEmpresa',     i18nKey: 'col_nombreEmpresa',   hideForCliente: true },
        { key: 'nombreXLSX',        i18nKey: 'archivo' },
        { key: 'partName',          i18nKey: 'col_partName' },
        { key: 'detalles',          i18nKey: 'col_detalles' },
        { key: 'sku',               i18nKey: 'col_sku' },
        { key: 'partNumber',        i18nKey: 'col_part_number' },
        { key: 'brandName',         i18nKey: 'fabricante' },
        { key: 'modelo',            i18nKey: 'modelo' },
        { key: 'condicion',         i18nKey: 'condicion' },
        { key: 'horometro',         i18nKey: 'col_horometro',       align: 'right', isNumber: true },
        { key: 'anoFabricacion',    i18nKey: 'col_anoFabricacion',  align: 'right', isNumber: true },
        { key: 'odometro',          i18nKey: 'col_odometro',        align: 'right', isNumber: true },
        { key: 'bodegaUbicacion',   i18nKey: 'Warehouse / Location' },
        { key: 'categoriaOrigen',   i18nKey: 'col_categoriaOrigen' },
        { key: 'categoria_MM',      i18nKey: 'col_categoria_MM' },
        { key: 'precio',            i18nKey: 'precio',              align: 'right', isNumber: true, fmt: 'money' },
        { key: 'precioVenta',       i18nKey: 'col_precioVenta',     align: 'right', isNumber: true, fmt: 'money' },
        { key: 'cantidad',          i18nKey: 'cantidad',            align: 'right', isNumber: true },
        { key: 'unidadDeMedida',    i18nKey: 'unidad_medida' },
        { key: 'publicado',         i18nKey: 'col_publicado' },
        { key: 'vendido',           i18nKey: 'col_vendido' },
        { key: 'cantidadDisponible',i18nKey: 'cantidad_disponible', align: 'right', isNumber: true },
        { key: 'estadoVenta',       i18nKey: 'col_estadoVenta' },
        { key: 'fechaVenta',        i18nKey: 'col_fechaVenta' },
        { key: 'nombreUsuario',     i18nKey: 'col_nombreUsuario' },
      ],

      // Filtros por columna (client-side sobre la página actual)
      filterCol: {
        nombreEmpresa: '',
        nombreXLSX: '',
        partName: '', detalles: '', sku: '',
        partNumber: '', brandName: '', modelo: '', condicion: '',
        horometro: '', anoFabricacion: '', odometro: '', bodegaUbicacion: '',
        categoriaOrigen: '', categoria_MM: '',
        publicado: '',
        precio: '', precioVenta: '',
        cantidad: '', unidadDeMedida: '', vendido: '', cantidadDisponible: '',
        estadoVenta: '', fechaVenta: '',
        nombreUsuario: '', idMaterialETL: '',
      },

      // Ordenación
      ordenColumna: '',
      ordenDireccion: 'asc',

      // Paginación server-side
      currentPage: 1,
      pageSize: 50,

      // Vista
      tipoVista: '',
      mostrarResultados: false, // true solo después de presionar "Buscar"
      ecommerceRows: [],

      // Filtros y orden ecommerce
      filterColEco: { empresa: '', nombreXlsx: '', partName: '', brandName: '', detalles: '', categoriaInexlink: '', cantidad: '', fechaPublicacion: '' },
      ordenColumnaEco: '',
      ordenDireccionEco: 'asc',

      // Estado
      cargando: false,

      // Parámetros del servicio
      idUsuario: null,

      // Maestro de Materiales
      maestroRows: [],
      maestroTotal: null,
      maestroCurrentPage: 1,
      maestroPageSize: 50,
      maestroSearch: '',
      maestroSortBy: 'nombre_corto',
      maestroTax: Object.create(null), // { Categoria: {Clase, Segmento, Familia} }
      maestroCategoriaOptions: [],
      cargandoTaxonomias: false,
      filterColMaestro: {
        skuInexlink: '', brandName: '', partNumber: '', modelo: '', partName: '',
        detalles: '', categoria: '', segmento: '', familia: '', clase: '',
        token: '', fechaIntegracion: '', idOrigen: '',
      },
      ordenColumnaMaestro: '',
      ordenDireccionMaestro: 'asc',

      // Pre Maestro de Materiales
      preMaestroRows: [],
      preMaestroTotal: null,
      preMaestroCurrentPage: 1,
      preMaestroPageSize: 50,
      preMaestroSearch: '',
      preMaestroEstado: 'todos',
      checkedIdsPreMaestroCategoria: [],
      checkedIdsPreMaestroBrandName: [],
      showPreMaestroCategoriaModal: false,
      showPreMaestroBrandNameModal: false,
      selectedPreMaestroCategoria: null,
      selectedPreMaestroBrandName: '',
      preMaestroCategoriaApplyScope: 'selected',
      preMaestroBrandNameApplyScope: 'selected',
      isBulkApplyingPreMaestro: false,
      checkedIdsMaestroCategoria: [],
      checkedIdsMaestroBrandName: [],
      showMaestroCategoriaModal: false,
      showMaestroBrandNameModal: false,
      selectedMaestroCategoria: null,
      selectedMaestroBrandName: '',
      maestroCategoriaApplyScope: 'selected',
      maestroBrandNameApplyScope: 'selected',
      isBulkApplyingMaestro: false,
      filterColPreMaestro: {
        skuInexlink: '', partName: '', detalles: '', categoriaInexlink: '', brandName: '',
        partNumber: '', modelo: '', token: '', estado: '', fechaCarga: '', fechaIntegracion: '',
      },
      ordenColumnaPreMaestro: '',
      ordenDireccionPreMaestro: 'asc',
      preMaestroSelectedIds: [],

      eliminandoPreMaestroId: null,

      // Modal Detalle del Cluster (tabla Ecommerce, columna "Detalle")
      modalDetalleCluster: false,
      detalleClusterLoading: false,
      detalleClusterRows: [],
      detalleClusterFicha: null,
      filterColDetalleCluster: { partName: '', brandName: '', detalles: '', categoriaInexlink: '', cantidad: '' },
      ordenColumnaDetalleCluster: '',
      ordenDireccionDetalleCluster: 'asc',

      // Importación masiva desde Excel
      importandoPreMaestro: false,
      modalImportPreMaestro: false,
      validandoPreMaestro: false,
      modalValidarPreMaestro: false,
      validarResultado: null,
      integrandoTodo: false,
      importResultado: null,

      modalNuevoPreMaestro: false,
      guardandoPreMaestro: false,
      errorNuevoPreMaestro: '',
      preMaestroEditandoId: null,
      // FechaIntegracion no se edita: la escribe el sistema al integrar al Maestro.
      nuevoPreMaestro: {
        fechaCarga: '', partName: '', detalles: '',
        categoriaInexlink: '', brandName: '', partNumber: '', modelo: '',
      },
    }
  },

  computed: {
    rol() {
      return utilsService.getRol() || '';
    },
    // "ventas inex" ve todas las pestañas de Inventario pero solo en modo lectura: no
    // importa, integra ni edita filas. Mismo criterio que el resto de las vistas admin.
    puedeEscribir() {
      return utilsService.puedeEscribir() && this.rol !== 'ventas inex';
    },
    detalleClusterTitulo() {
      const f = this.detalleClusterFicha;
      return f ? `${this.$t('detalle_cluster')} — ${f.nombreXlsx}` : this.$t('detalle_cluster');
    },
    exportColumns() {
      return this.columns
        .filter(c => !c.hideForCliente || this.rol !== 'cliente')
        .map(c => ({ ...c, label: this.$t(c.i18nKey) }));
    },
    showEmpresaBadge() {
      return (this.rol === 'cliente' || this.rol === 'ventas inex') && this.empresas.length === 1;
    },
    // Busqueda y orden por columna del modal Detalle del Cluster, mismo criterio que
    // processedEcommerceRows: filtra y ordena en memoria sobre lo que ya se cargo.
    processedDetalleClusterRows() {
      let rows = Array.isArray(this.detalleClusterRows) ? this.detalleClusterRows.slice() : [];
      const f = this.filterColDetalleCluster;
      rows = rows.filter(r => {
        for (const k in f) {
          const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
          if (!needle) continue;
          const cell = String(r && r[k] != null ? r[k] : '').toLowerCase();
          if (cell.indexOf(needle) === -1) return false;
        }
        return true;
      });
      if (this.ordenColumnaDetalleCluster) {
        const key = this.ordenColumnaDetalleCluster;
        const dir = this.ordenDireccionDetalleCluster === 'asc' ? 1 : -1;
        rows.sort((a, b) => {
          const va = a && a[key] != null ? a[key] : '';
          const vb = b && b[key] != null ? b[key] : '';
          const na = parseFloat(va); const nb = parseFloat(vb);
          if (!isNaN(na) && !isNaN(nb)) return (na - nb) * dir;
          return String(va).localeCompare(String(vb)) * dir;
        });
      }
      return rows;
    },
    processedEcommerceRows() {
      let rows = Array.isArray(this.ecommerceRows) ? this.ecommerceRows.slice() : [];
      const f = this.filterColEco;
      rows = rows.filter(r => {
        for (const k in f) {
          const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
          if (!needle) continue;
          let cellValue = r && r[k] != null ? r[k] : '';
          if (k === 'fechaPublicacion' && cellValue) {
            cellValue = new Date(cellValue).toLocaleDateString('es-CL');
          }
          const cell = String(cellValue).toLowerCase();
          if (cell.indexOf(needle) === -1) return false;
        }
        return true;
      });
      if (this.ordenColumnaEco) {
        const key = this.ordenColumnaEco;
        const dir = this.ordenDireccionEco === 'asc' ? 1 : -1;
        rows.sort((a, b) => {
          const va = a && a[key] != null ? a[key] : '';
          const vb = b && b[key] != null ? b[key] : '';
          const na = parseFloat(va); const nb = parseFloat(vb);
          if (!isNaN(na) && !isNaN(nb)) return (na - nb) * dir;
          return String(va).localeCompare(String(vb)) * dir;
        });
      }
      return rows;
    },

    processedRows() {
      // publicado se pasa al texto que se ve en la celda para que el buscador y el orden por
      // columna trabajen sobre eso; el booleano se conserva aparte para pintar el badge.
      let rows = (Array.isArray(this.materialRows) ? this.materialRows : []).map(r =>
        Object.assign({}, r, {
          publicadoFlag: r && r.publicado === true,
          publicado: r && r.publicado ? this.$t('si') : this.$t('no'),
        })
      );

      // Filtros por columna (client-side sobre la página actual)
      const f = this.filterCol;
      rows = rows.filter(r => {
        for (const k in f) {
          if (!Object.prototype.hasOwnProperty.call(f, k)) continue;
          const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
          if (!needle) continue;
          const cell = String(r && r[k] != null ? r[k] : '').toLowerCase();
          if (cell.indexOf(needle) === -1) return false;
        }
        return true;
      });

      // Ordenación
      if (this.ordenColumna) {
        const key = this.ordenColumna;
        const dir = this.ordenDireccion === 'asc' ? 1 : -1;
        rows.sort((a, b) => {
          const va = a && a[key] != null ? a[key] : '';
          const vb = b && b[key] != null ? b[key] : '';
          const na = parseFloat(va); const nb = parseFloat(vb);
          if (!isNaN(na) && !isNaN(nb)) return (na - nb) * dir;
          return String(va).localeCompare(String(vb)) * dir;
        });
      }

      return rows;
    },

    totalPagesServer() {
      const size = Number(this.pageSize || 50);
      if (size >= 999999) return 1;
      if (this.materialTotal != null) return Math.max(1, Math.ceil(Number(this.materialTotal) / size));
      if (Array.isArray(this.materialRows) && this.materialRows.length < size) return this.currentPage;
      return this.currentPage + 1;
    },

    nombreEmpresaSeleccionada() {
      if (this.empresaSeleccionada === 0) return this.$t('todas');
      const e = this.empresas.find(x => x.id === this.empresaSeleccionada);
      return e ? (e.nombre || '') : '';
    },

    processedMaestroRows() {
      let rows = Array.isArray(this.maestroRows) ? this.maestroRows.slice() : [];
      const f = this.filterColMaestro;
      rows = rows.filter(r => {
        for (const k in f) {
          const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
          if (!needle) continue;
          const cell = String(r && r[k] != null ? r[k] : '').toLowerCase();
          if (cell.indexOf(needle) === -1) return false;
        }
        return true;
      });
      if (this.ordenColumnaMaestro) {
        const key = this.ordenColumnaMaestro;
        const dir = this.ordenDireccionMaestro === 'asc' ? 1 : -1;
        rows.sort((a, b) => {
          const va = a && a[key] != null ? a[key] : '';
          const vb = b && b[key] != null ? b[key] : '';
          return String(va).localeCompare(String(vb)) * dir;
        });
      }
      return rows;
    },

    totalPagesMaestro() {
      const size = Number(this.maestroPageSize || 50);
      if (this.maestroTotal != null) return Math.max(1, Math.ceil(Number(this.maestroTotal) / size));
      if (Array.isArray(this.maestroRows) && this.maestroRows.length < size) return this.maestroCurrentPage;
      return this.maestroCurrentPage + 1;
    },

    // Con "Todos" la grilla mezcla pendientes e integrados, pero lo ya integrado no se puede
    // volver a integrar: la casilla solo aparece donde tiene sentido.
    mostrarSeleccionPreMaestro() {
      return this.preMaestroEstado !== 'integrados';
    },

    processedPreMaestroRows() {
      // El estado se deriva acá y no en la consulta para que siga el idioma de la sesión, y para
      // que el buscador y el orden por columna funcionen sobre el texto que se ve en pantalla.
      let rows = (Array.isArray(this.preMaestroRows) ? this.preMaestroRows : []).map(r =>
        Object.assign({}, r, { estado: r && r.integrado ? this.$t('integrado') : this.$t('pendiente') })
      );
      const f = this.filterColPreMaestro;
      rows = rows.filter(r => {
        for (const k in f) {
          const needle = String(f[k] == null ? '' : f[k]).trim().toLowerCase();
          if (!needle) continue;
          const cell = String(r && r[k] != null ? r[k] : '').toLowerCase();
          if (cell.indexOf(needle) === -1) return false;
        }
        return true;
      });
      if (this.ordenColumnaPreMaestro) {
        const key = this.ordenColumnaPreMaestro;
        const dir = this.ordenDireccionPreMaestro === 'asc' ? 1 : -1;
        rows.sort((a, b) => {
          const va = a && a[key] != null ? a[key] : '';
          const vb = b && b[key] != null ? b[key] : '';
          return String(va).localeCompare(String(vb)) * dir;
        });
      }
      return rows;
    },

    totalPagesPreMaestro() {
      const size = Number(this.preMaestroPageSize || 50);
      if (this.preMaestroTotal != null) return Math.max(1, Math.ceil(Number(this.preMaestroTotal) / size));
      if (Array.isArray(this.preMaestroRows) && this.preMaestroRows.length < size) return this.preMaestroCurrentPage;
      return this.preMaestroCurrentPage + 1;
    },

    preMaestroSelectableIds() {
      return this.processedPreMaestroRows.filter(r => !r.integrado).map(r => r.id);
    },

    preMaestroAllChecked() {
      const ids = this.preMaestroSelectableIds;
      return ids.length > 0 && ids.every(id => this.preMaestroSelectedIds.includes(id));
    },
    preMaestroCategoriaAllChecked() {
      const ids = this.preMaestroSelectableIds;
      return ids.length > 0 && ids.every(id => this.checkedIdsPreMaestroCategoria.includes(id));
    },
    preMaestroBrandNameAllChecked() {
      const ids = this.preMaestroSelectableIds;
      return ids.length > 0 && ids.every(id => this.checkedIdsPreMaestroBrandName.includes(id));
    },
    maestroSelectableIds() {
      return this.processedMaestroRows.map(r => r.id);
    },
    maestroCategoriaAllChecked() {
      const ids = this.maestroSelectableIds;
      return ids.length > 0 && ids.every(id => this.checkedIdsMaestroCategoria.includes(id));
    },
    maestroBrandNameAllChecked() {
      const ids = this.maestroSelectableIds;
      return ids.length > 0 && ids.every(id => this.checkedIdsMaestroBrandName.includes(id));
    },
  },

  async mounted() {
    this.$store.dispatch('setSidebarCollapsed', false);
    const uinfo = (utilsService.getUserInfo && utilsService.getUserInfo()) || {};
    this.idUsuario = Number(uinfo.userId || uinfo.idUsuario || uinfo.id || uinfo.UserId || 0) || null;
    await this.cargarEmpresasInicial();
    window.addEventListener('scroll', this._onWindowScroll);
  },

  beforeDestroy() {
    this.$store.dispatch('setSidebarCollapsed', false);
    window.removeEventListener('scroll', this._onWindowScroll);
  },

  watch: {
    filterCol: { deep: true, handler() { /* filtro client-side, no resetear página */ } },
    tipoVista() {
      // Cambiar el Tipo de Vista no dispara ninguna búsqueda: solo oculta
      // los resultados de la búsqueda anterior hasta que se presione "Buscar".
      this.mostrarResultados = false;
    },
  },

  methods: {
    // ===== Empresas =====
    async cargarEmpresasInicial() {
      const user = utilsService.getUserInfo() || {};
      const rol = String(user.rol || '').toLowerCase();
      let empresas = [];

      try { empresas = await empresaService.getEmpresasByUser(); } catch (_) {}
      if ((!empresas || empresas.length === 0) && (rol === 'cliente' || rol === 'ventas inex') && user.clienteId) {
        try { empresas = await empresaService.getEmpresasByCliente(user.clienteId); } catch (_) {}
      }
      if ((!empresas || empresas.length === 0) && rol === 'admin') {
        try { empresas = await empresaService.getEmpresas(); } catch (_) {}
      }

      this.empresas = (empresas || []).map(e => ({
        id: e && (e.id != null ? e.id : e.Id),
        nombre: e && (e.nombre != null ? e.nombre : e.Nombre),
      })).filter(e => e && e.id != null);

      if (this.empresas.length > 1) {
        this.empresaSeleccionada = 0;
      } else if (this.empresas.length === 1) {
        this.empresaSeleccionada = this.empresas[0].id;
      } else {
        this.empresaSeleccionada = null;
      }
      await this.onEmpresaChange();
    },

    onEmpresaChange() {
      this.currentPage = 1;
      this.ordenColumna = '';
      this.ordenDireccion = 'asc';
      this.limpiarFiltros();
      this.limpiarResultadosVista();
      this.mostrarResultados = false;
    },

    limpiarResultadosVista() {
      this.materialRows = [];
      this.materialTotal = null;
      this.ecommerceRows = [];
      this.maestroRows = [];
      this.maestroTotal = null;
      this.preMaestroRows = [];
      this.preMaestroTotal = null;
    },

    async buscar() {
      if (!this.tipoVista || this.cargando) return;
      this.mostrarResultados = true;
      if (this.tipoVista === 'ecommerce') {
        await this.cargarPublicadoEcommerce();
      } else if (this.tipoVista === 'maestro_materiales') {
        this.maestroCurrentPage = 1;
        if (this.maestroCategoriaOptions.length === 0) await this.loadMaestroTaxonomias();
        await this.cargarMaestroMateriales();
      } else if (this.tipoVista === 'pre_maestro_materiales') {
        this.preMaestroCurrentPage = 1;
        await this.cargarPreMaestroMateriales();
      } else {
        this.currentPage = 1;
        await this.cargarMaterialesEmpresa();
      }
    },

    async cargarPublicadoEcommerce() {
      this.cargando = true;
      try {
        const data = await materialService.getPublicadoEcommerce(this.empresaSeleccionada || 0);
        this.ecommerceRows = Array.isArray(data) ? data : [];
      } catch (e) {
        this.ecommerceRows = [];
        console.error('Error cargando publicado ecommerce:', e);
      } finally {
        this.cargando = false;
      }
    },

    // Un Cluster es un solo producto en el ecommerce (asi lo trata cargarPublicadoEcommerce,
    // que ya no lo desdobla por material); esto abre lo que hay detras: los materiales que
    // componen ese lote, via /publicadoEcommerce/detalleCluster/{idFicha}.
    async abrirDetalleCluster(row) {
      this.detalleClusterFicha = row;
      this.detalleClusterRows = [];
      // Busqueda y orden se reinician: son de este Cluster puntual, no tendria sentido
      // que un filtro escrito para uno arrastrara al siguiente que se abra.
      this.filterColDetalleCluster = { partName: '', brandName: '', detalles: '', categoriaInexlink: '', cantidad: '' };
      this.ordenColumnaDetalleCluster = '';
      this.ordenDireccionDetalleCluster = 'asc';
      this.detalleClusterLoading = true;
      this.modalDetalleCluster = true;
      try {
        const data = await materialService.getDetalleFichaCluster(row.idFicha);
        this.detalleClusterRows = Array.isArray(data) ? data : [];
      } catch (e) {
        console.error('Error cargando el detalle del cluster:', e);
      } finally {
        this.detalleClusterLoading = false;
      }
    },

    // ===== Materiales =====
    async cargarMaterialesEmpresa() {
      if (this.empresaSeleccionada === null || this.empresaSeleccionada === undefined) {
        this.materialRows = [];
        this.materialTotal = null;
        return;
      }
      this.cargando = true;
      try {
        const resp = await materialService.getMaterialAll(
          this.empresaSeleccionada,
          this.currentPage,
          this.pageSize,
          { idUsuario: this.idUsuario, fecha: '1900-01-01' },
          this.lang
        );

        let items = [];
        if (Array.isArray(resp)) {
          items = resp;
        } else if (resp) {
          items = resp.items || resp.data || [];
        }
        if (!Array.isArray(items)) items = [];

        let totalRaw = null;
        if (!Array.isArray(resp) && resp) {
          if (resp.total != null) totalRaw = resp.total;
          else if (resp.totalCount != null) totalRaw = resp.totalCount;
          else if (resp.totalcount != null) totalRaw = resp.totalcount;
          else if (resp.TotalCount != null) totalRaw = resp.TotalCount;
        }

        this.materialRows = items;
        this.materialTotal = totalRaw !== null ? Number(totalRaw) : null;

      } catch (e) {
        this.materialRows = [];
        this.materialTotal = null;
        console.error('Error cargando materiales:', e);
      } finally {
        this.cargando = false;
      }
    },

    // ===== Paginación =====
    async onPageChange(p) {
      const n = Math.max(1, Math.min(Number(p), this.totalPagesServer));
      this.currentPage = n;
      await this.cargarMaterialesEmpresa();
    },

    async onPageSizeChange(s) {
      this.pageSize = Math.max(1, Number(s));
      this.currentPage = 1;
      await this.cargarMaterialesEmpresa();
    },

    // ===== Ordenación Ecommerce =====
    ordenarEco(columna) {
      if (this.ordenColumnaEco === columna) {
        this.ordenDireccionEco = this.ordenDireccionEco === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumnaEco = columna;
        this.ordenDireccionEco = 'asc';
      }
    },
    iconoOrdenEco(columna) {
      if (this.ordenColumnaEco !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccionEco === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    ordenarDetalleCluster(columna) {
      if (this.ordenColumnaDetalleCluster === columna) {
        this.ordenDireccionDetalleCluster = this.ordenDireccionDetalleCluster === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumnaDetalleCluster = columna;
        this.ordenDireccionDetalleCluster = 'asc';
      }
    },
    iconoOrdenDetalleCluster(columna) {
      if (this.ordenColumnaDetalleCluster !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccionDetalleCluster === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    // ===== Ordenación =====
    ordenarPor(columna) {
      if (this.ordenColumna === columna) {
        this.ordenDireccion = this.ordenDireccion === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumna = columna;
        this.ordenDireccion = 'asc';
      }
    },

    iconoOrden(columna) {
      if (this.ordenColumna !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccion === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    // ===== Filtros =====
    limpiarFiltros() {
      for (const k in this.filterCol) {
        this.$set(this.filterCol, k, '');
      }
      for (const k in this.filterColEco) {
        this.$set(this.filterColEco, k, '');
      }
    },

    // ===== Maestro Materiales =====
    async cargarMaestroMateriales() {
      this.cargando = true;
      this.checkedIdsMaestroCategoria = [];
      this.checkedIdsMaestroBrandName = [];
      try {
        const resp = await materialService.getMaestroMateriales(
          this.maestroCurrentPage,
          this.maestroPageSize,
          this.maestroSearch,
          this.maestroSortBy
        );
        this.maestroRows = Array.isArray(resp.items) ? resp.items : [];
        this.maestroTotal = resp.total != null ? Number(resp.total) : null;
      } catch (e) {
        this.maestroRows = [];
        this.maestroTotal = null;
        console.error('Error cargando Maestro Materiales:', e);
      } finally {
        this.cargando = false;
      }
    },

    async onMaestroPageChange(p) {
      const n = Math.max(1, Math.min(Number(p), this.totalPagesMaestro));
      this.maestroCurrentPage = n;
      await this.cargarMaestroMateriales();
    },

    async onMaestroPageSizeChange(s) {
      this.maestroPageSize = Math.max(1, Number(s));
      this.maestroCurrentPage = 1;
      await this.cargarMaestroMateriales();
    },

    async onMaestroSearchChange() {
      this.maestroCurrentPage = 1;
      await this.cargarMaestroMateriales();
    },

    ordenarMaestro(columna) {
      if (this.ordenColumnaMaestro === columna) {
        this.ordenDireccionMaestro = this.ordenDireccionMaestro === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumnaMaestro = columna;
        this.ordenDireccionMaestro = 'asc';
      }
    },

    iconoOrdenMaestro(columna) {
      if (this.ordenColumnaMaestro !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccionMaestro === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    scrollMaestro(dir) {
      const el = this.$refs.tablaMaestro;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    // ===== Pre Maestro Materiales =====
    async cargarPreMaestroMateriales() {
      this.cargando = true;
      this.preMaestroSelectedIds = [];
      this.checkedIdsPreMaestroCategoria = [];
      this.checkedIdsPreMaestroBrandName = [];
      try {
        const resp = await materialService.getPreMaestroMateriales(
          this.preMaestroCurrentPage,
          this.preMaestroPageSize,
          this.preMaestroSearch,
          this.preMaestroEstado
        );
        this.preMaestroRows = Array.isArray(resp.items) ? resp.items : [];
        this.preMaestroTotal = resp.total != null ? Number(resp.total) : null;
      } catch (e) {
        this.preMaestroRows = [];
        this.preMaestroTotal = null;
        console.error('Error cargando Pre Maestro Materiales:', e);
      } finally {
        this.cargando = false;
      }
    },

    togglePreMaestroSelectAll(checked) {
      if (!this.puedeEscribir) return;
      const ids = this.preMaestroSelectableIds;
      if (checked) {
        ids.forEach(id => {
          if (!this.preMaestroSelectedIds.includes(id)) this.preMaestroSelectedIds.push(id);
        });
      } else {
        this.preMaestroSelectedIds = this.preMaestroSelectedIds.filter(id => !ids.includes(id));
      }
    },

    abrirPreMaestroCategoriaModal() {
      // El selector de categoria vive en el modal, igual que en abrirEditarPreMaestro: si
      // se entro al Pre-Maestro sin abrir antes el modal individual, la taxonomia no se pidio.
      if (this.maestroCategoriaOptions.length === 0) this.loadMaestroTaxonomias();
      this.showPreMaestroCategoriaModal = true;
    },

    toggleAllChecksPreMaestroCategoria(checked) {
      if (!this.puedeEscribir) return;
      this.checkedIdsPreMaestroCategoria = checked ? [...this.preMaestroSelectableIds] : [];
    },

    toggleAllChecksPreMaestroBrandName(checked) {
      if (!this.puedeEscribir) return;
      this.checkedIdsPreMaestroBrandName = checked ? [...this.preMaestroSelectableIds] : [];
    },

    // Aplica Fabricante o Categoria Inexlink en bloque: a los ids tildados, o a todos los
    // pendientes que coincidan con la busqueda actual (scope 'all'). Persiste de inmediato en
    // ambos casos, a diferencia de MaterialesResultFile.vue, porque aca no hay un flujo de
    // edicion en memoria + guardado general para Pre Maestro.
    async aplicarPreMaestroBulk({ tipo, valor, scope, ids }) {
      if (this.isBulkApplyingPreMaestro) return false;

      if (scope === 'all') {
        const resumen = await materialService.getPreMaestroMateriales(1, 1, this.preMaestroSearch, 'pendientes');
        const total = (resumen && resumen.total) || 0;
        if (!total) {
          Swal.fire({ icon: 'info', title: this.$t('modal_informacion'), text: this.$t('aplicar_todos_pre_maestro_sin_pendientes') });
          return false;
        }
        const filtrado = !!(this.preMaestroSearch && this.preMaestroSearch.trim());
        const confirma = await Swal.fire({
          icon: 'warning',
          title: this.$t('confirmar_aplicar_todos'),
          html: this.$t(filtrado ? 'aviso_aplicar_todos_pre_maestro_filtrado' : 'aviso_aplicar_todos_pre_maestro')
            .replace('{n}', total)
            .replace('{busqueda}', this.escaparHtmlPreMaestro(this.preMaestroSearch || '')),
          showCancelButton: true,
          confirmButtonText: this.$t('si_aplicar'),
          cancelButtonText: this.$t('cancelar'),
        });
        if (!confirma.value) return false;

        this.isBulkApplyingPreMaestro = true;
        try {
          await materialService.updatePreMaestroBulk({ AplicarATodos: true, Search: this.preMaestroSearch || null, Tipo: tipo, Valor: valor });
          await this.cargarPreMaestroMateriales();
          Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), 'success');
          return true;
        } catch (e) {
          console.error('[updatePreMaestroBulk] error:', e);
          Swal.fire('Error', this.$t('no_se_pudo_guardar_cambios'), 'error');
          return false;
        } finally {
          this.isBulkApplyingPreMaestro = false;
        }
      }

      if (!ids.length) {
        Toast.fire({ icon: 'warning', title: this.$t('seleccione_registros_integrar') });
        return false;
      }
      this.isBulkApplyingPreMaestro = true;
      try {
        await materialService.updatePreMaestroBulk({ AplicarATodos: false, Ids: ids, Tipo: tipo, Valor: valor });
        await this.cargarPreMaestroMateriales();
        Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), 'success');
        return true;
      } catch (e) {
        console.error('[updatePreMaestroBulk] error:', e);
        Swal.fire('Error', this.$t('no_se_pudo_guardar_cambios'), 'error');
        return false;
      } finally {
        this.isBulkApplyingPreMaestro = false;
      }
    },

    async aplicarPreMaestroCategoriaSeleccionada() {
      if (!this.puedeEscribir || !this.selectedPreMaestroCategoria) return;
      const ok = await this.aplicarPreMaestroBulk({
        tipo: 'CategoriaInexlink', valor: this.selectedPreMaestroCategoria,
        scope: this.preMaestroCategoriaApplyScope, ids: this.checkedIdsPreMaestroCategoria,
      });
      if (ok) {
        this.showPreMaestroCategoriaModal = false;
        this.selectedPreMaestroCategoria = null;
        this.checkedIdsPreMaestroCategoria = [];
        this.preMaestroCategoriaApplyScope = 'selected';
      }
    },

    async aplicarPreMaestroBrandNameSeleccionada() {
      if (!this.puedeEscribir) return;
      const valor = (this.selectedPreMaestroBrandName || '').trim();
      const ok = await this.aplicarPreMaestroBulk({
        tipo: 'BrandName', valor: valor || null,
        scope: this.preMaestroBrandNameApplyScope, ids: this.checkedIdsPreMaestroBrandName,
      });
      if (ok) {
        this.showPreMaestroBrandNameModal = false;
        this.selectedPreMaestroBrandName = '';
        this.checkedIdsPreMaestroBrandName = [];
        this.preMaestroBrandNameApplyScope = 'selected';
      }
    },

    abrirMaestroCategoriaModal() {
      // El selector de categoria vive en el modal: si se entro a Maestro Materiales sin abrir
      // antes una fila (que dispara onMaestroCategoriaChange), la taxonomia no se pidio.
      if (this.maestroCategoriaOptions.length === 0) this.loadMaestroTaxonomias();
      this.showMaestroCategoriaModal = true;
    },

    toggleAllChecksMaestroCategoria(checked) {
      if (!this.puedeEscribir) return;
      this.checkedIdsMaestroCategoria = checked ? [...this.maestroSelectableIds] : [];
    },

    toggleAllChecksMaestroBrandName(checked) {
      if (!this.puedeEscribir) return;
      this.checkedIdsMaestroBrandName = checked ? [...this.maestroSelectableIds] : [];
    },

    // Aplica Fabricante o Categoria en bloque sobre dbo.MaestroMateriales: a los ids tildados, o
    // a todos los registros que coincidan con la busqueda actual (scope 'all'). Persiste de
    // inmediato en ambos casos, igual que el bulk de Pre-Maestro.
    async aplicarMaestroBulk({ tipo, valor, scope, ids }) {
      if (this.isBulkApplyingMaestro) return false;

      if (scope === 'all') {
        const resumen = await materialService.getMaestroMateriales(1, 1, this.maestroSearch, this.maestroSortBy);
        const total = (resumen && resumen.total) || 0;
        if (!total) {
          Swal.fire({ icon: 'info', title: this.$t('modal_informacion'), text: this.$t('aplicar_todos_maestro_sin_resultados') });
          return false;
        }
        const filtrado = !!(this.maestroSearch && this.maestroSearch.trim());
        const confirma = await Swal.fire({
          icon: 'warning',
          title: this.$t('confirmar_aplicar_todos'),
          html: this.$t(filtrado ? 'aviso_aplicar_todos_maestro_filtrado' : 'aviso_aplicar_todos_maestro')
            .replace('{n}', total)
            .replace('{busqueda}', this.escaparHtmlPreMaestro(this.maestroSearch || '')),
          showCancelButton: true,
          confirmButtonText: this.$t('si_aplicar'),
          cancelButtonText: this.$t('cancelar'),
        });
        if (!confirma.value) return false;

        this.isBulkApplyingMaestro = true;
        try {
          await materialService.updateMaestroBulk({ AplicarATodos: true, Search: this.maestroSearch || null, Tipo: tipo, Valor: valor });
          await this.cargarMaestroMateriales();
          Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), 'success');
          return true;
        } catch (e) {
          console.error('[updateMaestroBulk] error:', e);
          Swal.fire('Error', this.$t('no_se_pudo_guardar_cambios'), 'error');
          return false;
        } finally {
          this.isBulkApplyingMaestro = false;
        }
      }

      if (!ids.length) {
        Toast.fire({ icon: 'warning', title: this.$t('seleccione_registros_integrar') });
        return false;
      }
      this.isBulkApplyingMaestro = true;
      try {
        await materialService.updateMaestroBulk({ AplicarATodos: false, Ids: ids, Tipo: tipo, Valor: valor });
        await this.cargarMaestroMateriales();
        Swal.fire(this.$t('exito'), this.$t('cambios_guardados'), 'success');
        return true;
      } catch (e) {
        console.error('[updateMaestroBulk] error:', e);
        Swal.fire('Error', this.$t('no_se_pudo_guardar_cambios'), 'error');
        return false;
      } finally {
        this.isBulkApplyingMaestro = false;
      }
    },

    async aplicarMaestroCategoriaSeleccionada() {
      if (!this.puedeEscribir || !this.selectedMaestroCategoria) return;
      const ok = await this.aplicarMaestroBulk({
        tipo: 'Categoria', valor: this.selectedMaestroCategoria,
        scope: this.maestroCategoriaApplyScope, ids: this.checkedIdsMaestroCategoria,
      });
      if (ok) {
        this.showMaestroCategoriaModal = false;
        this.selectedMaestroCategoria = null;
        this.checkedIdsMaestroCategoria = [];
        this.maestroCategoriaApplyScope = 'selected';
      }
    },

    async aplicarMaestroBrandNameSeleccionada() {
      if (!this.puedeEscribir) return;
      const valor = (this.selectedMaestroBrandName || '').trim();
      const ok = await this.aplicarMaestroBulk({
        tipo: 'BrandName', valor: valor || null,
        scope: this.maestroBrandNameApplyScope, ids: this.checkedIdsMaestroBrandName,
      });
      if (ok) {
        this.showMaestroBrandNameModal = false;
        this.selectedMaestroBrandName = '';
        this.checkedIdsMaestroBrandName = [];
        this.maestroBrandNameApplyScope = 'selected';
      }
    },

    async integrarPreMaestroAMM() {
      if (!this.puedeEscribir) return;
      if (this.preMaestroSelectedIds.length === 0) {
        Toast.fire({ icon: 'warning', title: this.$t('seleccione_registros_integrar') });
        return;
      }
      const confirm = await Swal.fire({
        title: this.$t('integrar_a_mm'),
        text: this.$t('confirmar_integrar_mm'),
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('si_confirmar'),
        cancelButtonText: this.$t('cancelar'),
      });
      if (!confirm.isConfirmed) return;

      this.cargando = true;
      try {
        const resp = await materialService.integrarPreMaestroMaterialesAMM(this.preMaestroSelectedIds);
        const n = (resp && resp.integrados != null) ? resp.integrados : this.preMaestroSelectedIds.length;
        await Swal.fire({
          title: this.$t('listo'),
          text: this.$t('registros_integrados_mm').replace('{n}', n),
          icon: 'success',
          confirmButtonText: this.$t('entendido'),
        });
        await this.cargarPreMaestroMateriales();
      } catch (e) {
        console.error('[integrarPreMaestroAMM] error:', e);
        Toast.fire({ icon: 'error', title: this.$t('error_integrar_mm') });
      } finally {
        this.cargando = false;
      }
    },

    async integrarTodoPreMaestroAMM() {
      if (!this.puedeEscribir || this.integrandoTodo) return;

      this.integrandoTodo = true;
      try {
        // Se pregunta el total al backend con el mismo filtro de la grilla: el usuario tiene que
        // ver cuantos va a integrar antes de confirmar, no despues.
        const resumen = await materialService.getPreMaestroMateriales(1, 1, this.preMaestroSearch, 'pendientes');
        const total = (resumen && resumen.total) || 0;

        if (!total) {
          Swal.fire({ icon: 'info', title: this.$t('integrar_todo'), text: this.$t('integrar_todo_sin_pendientes') });
          return;
        }

        const filtrado = !!(this.preMaestroSearch && this.preMaestroSearch.trim());
        const confirma = await Swal.fire({
          icon: 'warning',
          title: this.$t('integrar_todo'),
          html: this.$t(filtrado ? 'integrar_todo_confirmar_filtrado' : 'integrar_todo_confirmar')
            .replace('{n}', total)
            .replace('{busqueda}', this.escaparHtmlPreMaestro(this.preMaestroSearch || '')),
          showCancelButton: true,
          confirmButtonText: this.$t('continuar'),
          cancelButtonText: this.$t('cancelar'),
        });
        if (!confirma.value) return;

        this.cargando = true;
        const resp = await materialService.integrarTodoPreMaestroAMM(this.preMaestroSearch || null);
        const n = (resp && resp.integrados != null) ? resp.integrados : total;

        await Swal.fire({
          icon: 'success',
          title: this.$t('listo'),
          text: this.$t('registros_integrados_mm').replace('{n}', n),
          confirmButtonText: this.$t('entendido'),
        });

        this.preMaestroSelectedIds = [];
        await this.cargarPreMaestroMateriales();
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || '';
        Swal.fire({ icon: 'error', title: this.$t('error_integrar_mm'), text: msg });
      } finally {
        this.integrandoTodo = false;
        this.cargando = false;
      }
    },

    // El termino de busqueda lo escribe el usuario y se muestra dentro del html del Swal.
    escaparHtmlPreMaestro(v) {
      return String(v == null ? '' : v)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },

    async onPreMaestroPageChange(p) {
      const n = Math.max(1, Math.min(Number(p), this.totalPagesPreMaestro));
      this.preMaestroCurrentPage = n;
      await this.cargarPreMaestroMateriales();
    },

    async onPreMaestroPageSizeChange(s) {
      this.preMaestroPageSize = Math.max(1, Number(s));
      this.preMaestroCurrentPage = 1;
      await this.cargarPreMaestroMateriales();
    },

    async onPreMaestroSearchChange() {
      this.preMaestroCurrentPage = 1;
      await this.cargarPreMaestroMateriales();
    },

    ordenarPreMaestro(columna) {
      if (this.ordenColumnaPreMaestro === columna) {
        this.ordenDireccionPreMaestro = this.ordenDireccionPreMaestro === 'asc' ? 'desc' : 'asc';
      } else {
        this.ordenColumnaPreMaestro = columna;
        this.ordenDireccionPreMaestro = 'asc';
      }
    },

    iconoOrdenPreMaestro(columna) {
      if (this.ordenColumnaPreMaestro !== columna) return 'fas fa-sort text-muted';
      return this.ordenDireccionPreMaestro === 'asc' ? 'fas fa-sort-up' : 'fas fa-sort-down';
    },

    scrollPreMaestro(dir) {
      const el = this.$refs.tablaPreMaestro;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    abrirNuevoPreMaestro() {
      if (!this.puedeEscribir) return;
      this.resetNuevoPreMaestro();
      this.modalNuevoPreMaestro = true;
    },

    async eliminarPreMaestro(row) {
      // Los integrados no se eliminan: el botón no se muestra, y el backend lo rechaza igual.
      if (!this.puedeEscribir || !row || !row.id || row.integrado) return;

      const { isConfirmed } = await Swal.fire({
        icon: 'warning',
        title: this.$t('esta_seguro'),
        html: `${this.$t('confirmar_eliminar_pre_maestro')}<br><strong>${row.partName || ''}</strong>`,
        showCancelButton: true,
        confirmButtonText: this.$t('eliminar'),
        cancelButtonText: this.$t('cancelar'),
        confirmButtonColor: '#dc3545',
      });
      if (!isConfirmed) return;

      this.eliminandoPreMaestroId = row.id;
      try {
        await materialService.deletePreMaestroMaterial(row.id);
        // Deja de estar seleccionado, o el conteo de "Integrar a MM" contaría una fila inexistente.
        this.preMaestroSelectedIds = this.preMaestroSelectedIds.filter(id => id !== row.id);
        Toast.fire({ icon: 'success', title: this.$t('registro_eliminado') });
        await this.cargarPreMaestroMateriales();
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || '';
        Swal.fire({ icon: 'error', title: this.$t('error_eliminar'), text: msg });
      } finally {
        this.eliminandoPreMaestroId = null;
      }
    },

    abrirEditarPreMaestro(row) {
      // Los integrados no se editan: el boton no se muestra, y esto cubre el resto de vias.
      if (!this.puedeEscribir || !row || row.integrado) return;
      // El selector de categoria vive en el modal, asi que la taxonomia se pide aca:
      // entrando por el Pre-Maestro no se habia cargado.
      if (this.maestroCategoriaOptions.length === 0) this.loadMaestroTaxonomias();
      this.preMaestroEditandoId = row.id;
      this.nuevoPreMaestro = {
        fechaCarga: row.fechaCarga ? String(row.fechaCarga).slice(0, 10) : '',
        partName: row.partName || '',
        detalles: row.detalles || '',
        categoriaInexlink: row.categoriaInexlink || '',
        brandName: row.brandName || '',
        partNumber: row.partNumber || '',
        modelo: row.modelo || '',
      };
      this.errorNuevoPreMaestro = '';
      this.modalNuevoPreMaestro = true;
    },

    // Columnas del Excel del Pre-Maestro. Cada campo acepta varios encabezados para tolerar los
    // archivos que arma el cliente a mano; el primero es el que lleva la plantilla.
    // Token y SkuInexlink no se piden: quedan en blanco, igual que en el alta manual.
    columnasImportPreMaestro() {
      return [
        { campo: 'partName',          label: this.$t('col_partName'),            alias: ['nombre corto', 'partname', 'part name', 'short name'], requerido: true },
        { campo: 'detalles',          label: this.$t('col_detalles'),            alias: ['nombre largo', 'detalles', 'detalle', 'long name', 'descripcion'] },
        { campo: 'categoriaInexlink', label: this.$t('col_categoria_inexlink'),  alias: ['categoria inexlink', 'categoria', 'category'] },
        { campo: 'brandName',         label: this.$t('fabricante'),              alias: ['fabricante', 'marca', 'brand name', 'brandname', 'manufacturer'] },
        { campo: 'partNumber',        label: this.$t('col_part_number'),         alias: ['part number', 'partnumber', 'numero de parte'] },
        { campo: 'modelo',            label: this.$t('modelo'),                  alias: ['modelo', 'model'] },
        // Fecha Carga no se lee del archivo: la pone el servidor en UTC al importar.
      ];
    },

    // Sin tildes, sin dobles espacios y en minúsculas: así "Categoría Inexlink" y
    // "CATEGORIA INEXLINK" resuelven al mismo campo.
    normalizarEncabezado(v) {
      return String(v == null ? '' : v)
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
    },

    descargarPlantillaPreMaestro() {
      const cols = this.columnasImportPreMaestro().map(c => ({ key: c.campo, label: c.label }));
      const ejemplo = [{
        partName: 'Filtro de combustible',
        detalles: 'Filtro de combustible primario para motor C15',
        categoriaInexlink: this.maestroCategoriaOptions && this.maestroCategoriaOptions.length ? this.maestroCategoriaOptions[0] : '',
        brandName: 'CATERPILLAR',
        partNumber: '1R-0750',
        modelo: 'C15',
      }];
      this.downloadBlob(this.toXLSXBlobWithCols(ejemplo, cols), 'PreMaestroMateriales_plantilla.xlsx');
    },

    async onImportarPreMaestroFile(ev) {
      const input = ev && ev.target;
      const file = input && input.files && input.files[0];
      // Se limpia siempre, o volver a elegir el mismo archivo no dispararia el evento.
      if (input) input.value = '';
      if (!file) return;

      this.importandoPreMaestro = true;
      this.importResultado = null;

      try {
        const buffer = await file.arrayBuffer();
        // cellDates evita que las fechas lleguen como el numero de serie de Excel.
        const wb = XLSX.read(new Uint8Array(buffer), { type: 'array', cellDates: true });
        const ws = wb.Sheets[wb.SheetNames[0]];
        if (!ws) { this.avisoImport(this.$t('import_sin_datos')); return; }

        // header:1 devuelve arreglos, que es lo que permite conservar el numero de fila real
        // del Excel para señalar los errores donde el usuario los ve.
        const matriz = XLSX.utils.sheet_to_json(ws, { header: 1, blankrows: true, defval: null });
        if (!matriz.length) { this.avisoImport(this.$t('import_sin_datos')); return; }

        const cols = this.columnasImportPreMaestro();
        const encabezados = (matriz[0] || []).map(this.normalizarEncabezado);
        const indices = {};
        cols.forEach(c => {
          const alias = c.alias.concat([this.normalizarEncabezado(c.label)]);
          indices[c.campo] = encabezados.findIndex(h => h && alias.indexOf(h) !== -1);
        });

        const faltantes = cols.filter(c => c.requerido && indices[c.campo] === -1).map(c => c.label);
        if (faltantes.length) {
          this.avisoImport(this.$t('import_falta_columna').replace('{cols}', faltantes.join(', ')));
          return;
        }

        const items = [];
        for (let i = 1; i < matriz.length; i++) {
          const fila = matriz[i] || [];
          const vacia = fila.every(v => v === null || v === undefined || String(v).trim() === '');
          if (vacia) continue;

          const item = { fila: i + 1 };   // +1 porque el Excel numera desde 1 y la 1 es el encabezado
          cols.forEach(c => {
            const idx = indices[c.campo];
            const raw = idx === -1 ? null : fila[idx];
            item[c.campo] = raw == null ? null : String(raw).trim();
          });
          items.push(item);
        }

        if (!items.length) { this.avisoImport(this.$t('import_sin_datos')); return; }
        if (items.length > 20000) {
          this.avisoImport(this.$t('import_max_filas').replace('{n}', items.length).replace('{max}', 20000));
          return;
        }

        const resp = await materialService.importarPreMaestro(items);
        this.importResultado = resp || null;
        this.modalImportPreMaestro = true;

        // Solo se recarga si algo entro: si fue rechazado, la grilla no cambio.
        if (resp && resp.insertados > 0) {
          Toast.fire({ icon: 'success', title: this.$t('import_ok').replace('{n}', resp.insertados) });
          await this.cargarPreMaestroMateriales();
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || '';
        this.avisoImport(msg || this.$t('error_generico'));
      } finally {
        this.importandoPreMaestro = false;
      }
    },

    // Proceso masivo: no sube nada. Toma del inventario (dbo.MaterialesFileETL) las filas de
    // cargas activas que aun no fueron evaluadas y deja en el Pre-Maestro los materiales que
    // faltan catalogar. Se corre primero en seco para que el usuario vea que va a pasar.
    async procesarPreMaestroDesdeEtl() {
      if (!this.puedeEscribir || this.validandoPreMaestro) return;

      this.validandoPreMaestro = true;
      this.validarResultado = null;

      try {
        const pend = await materialService.getPendientesPreMaestroEtl();
        if (!pend || !pend.filas) {
          Swal.fire({ icon: 'info', title: this.$t('validar_e_ingresar'), text: this.$t('validar_sin_pendientes') });
          return;
        }

        // Simulacion: mismo diagnostico, sin escribir. Es la unica forma de que el usuario
        // sepa cuantos SKU se van a crear antes de crearlos.
        const previo = await materialService.procesarPreMaestroEtl({ simular: true });

        const confirma = await Swal.fire({
          icon: 'question',
          title: this.$t('validar_e_ingresar'),
          html: this.$t('validar_confirmar')
            .replace('{filas}', previo.leidos)
            .replace('{archivos}', pend.archivos)
            .replace('{nuevos}', previo.insertados)
            .replace('{desde}', previo.skuDesde || '-')
            .replace('{hasta}', previo.skuHasta || '-'),
          showCancelButton: true,
          confirmButtonText: this.$t('continuar'),
          cancelButtonText: this.$t('cancelar'),
        });
        if (!confirma.value) return;

        const resp = await materialService.procesarPreMaestroEtl({ simular: false });
        this.validarResultado = resp || null;
        this.modalValidarPreMaestro = true;

        if (resp && resp.insertados > 0) {
          Toast.fire({ icon: 'success', title: this.$t('validar_ok').replace('{n}', resp.insertados) });
          await this.cargarPreMaestroMateriales();
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message) || (e && e.message) || '';
        this.avisoImport(msg || this.$t('error_generico'));
      } finally {
        this.validandoPreMaestro = false;
      }
    },

    // Ayuda de la pantalla: que hace cada boton y con que reglas. El texto vive en los
    // archivos de idioma; aca solo se arma la estructura.
    mostrarInfoPreMaestro() {
      const bloque = (icono, color, titulo, cuerpo, extra) =>
        `<div class="text-left mb-3">`
        + `<div class="font-weight-bold mb-1"><i class="fas ${icono} ${color} mr-2"></i>${titulo}</div>`
        + `<div class="small text-muted">${cuerpo}</div>`
        + (extra || '')
        + `</div>`;

      const lista = claves =>
        `<ul class="small text-muted mb-0 mt-1 pl-4">`
        + claves.map(k => `<li>${this.$t(k)}</li>`).join('')
        + `</ul>`;

      const html =
          bloque('fa-file-import', 'text-primary', this.$t('importar_excel'),
                 this.$t('pm_info_importar_excel'))
        + bloque('fa-download', 'text-secondary', this.$t('plantilla'),
                 this.$t('pm_info_plantilla'))
        + bloque('fa-boxes', 'text-info', this.$t('validar_e_ingresar'),
                 this.$t('pm_info_importar_inventario'),
                 `<div class="small font-weight-bold mt-2">${this.$t('pm_info_descartes_titulo')}</div>`
                 + lista(['pm_info_descarte_sku', 'pm_info_descarte_fabricante',
                          'pm_info_descarte_partnumber', 'pm_info_descarte_descripcion',
                          'pm_info_descarte_repetida', 'pm_info_descarte_maestro',
                          'pm_info_descarte_premaestro'])
                 + `<div class="small text-muted mt-2">${this.$t('pm_info_archivo_cerrado')}</div>`)
        + bloque('fa-arrow-right', 'text-primary', this.$t('integrar_a_mm'),
                 this.$t('pm_info_integrar'))
        + bloque('fa-angle-double-right', 'text-warning', this.$t('integrar_todo'),
                 this.$t('pm_info_integrar_todo'))
        + bloque('fa-file-excel', 'text-success', this.$t('exportar_excel'),
                 this.$t('pm_info_exportar'))
        + `<hr>`
        + `<div class="text-left">`
        + `<div class="font-weight-bold mb-1"><i class="fas fa-hashtag text-dark mr-2"></i>${this.$t('col_sku_inexlink')}</div>`
        + lista(['pm_info_sku_correlativo', 'pm_info_sku_cuando', 'pm_info_sku_maximo', 'pm_info_sku_llave'])
        + `</div>`;

      Swal.fire({
        title: this.$t('pm_info_titulo'),
        html,
        icon: 'info',
        width: 720,
        confirmButtonText: this.$t('entendido'),
      });
    },

    // Texto del motivo. El backend manda la constante; la traduccion vive aca.
    etiquetaMotivoDescarte(motivo) {
      const claves = {
        INGRESADA: 'motivo_ingresada',
        YA_TIENE_SKU: 'motivo_ya_tiene_sku',
        SIN_FABRICANTE: 'motivo_sin_fabricante',
        SIN_PART_NUMBER: 'motivo_sin_part_number',
        SIN_DESCRIPCION: 'motivo_sin_descripcion',
        DUPLICADA_EN_LOTE: 'motivo_duplicada_en_lote',
        YA_EN_MAESTRO: 'motivo_ya_en_maestro',
        YA_EN_PRE_MAESTRO: 'motivo_ya_en_pre_maestro',
        LARGO_EXCEDIDO: 'motivo_largo_excedido',
      };
      return claves[motivo] ? this.$t(claves[motivo]) : motivo;
    },

    avisoImport(mensaje) {
      Swal.fire({ icon: 'warning', title: this.$t('importar_excel'), text: mensaje });
    },

    resetNuevoPreMaestro() {
      this.nuevoPreMaestro = {
        fechaCarga: '', partName: '', detalles: '',
        categoriaInexlink: '', brandName: '', partNumber: '', modelo: '',
      };
      this.preMaestroEditandoId = null;
      this.errorNuevoPreMaestro = '';
    },

    async guardarNuevoPreMaestro() {
      if (!this.puedeEscribir) return;
      this.guardandoPreMaestro = true;
      this.errorNuevoPreMaestro = '';
      try {
        // fechaCarga no viaja: la fija el sistema al crear y no se edita despues.
        const { fechaCarga, ...datos } = this.nuevoPreMaestro;   // eslint-disable-line no-unused-vars
        if (this.preMaestroEditandoId) {
          await materialService.updatePreMaestroMaterial(this.preMaestroEditandoId, datos);
        } else {
          await materialService.createPreMaestroMaterial(datos);
        }
        const wasEditing = !!this.preMaestroEditandoId;
        this.modalNuevoPreMaestro = false;
        this.resetNuevoPreMaestro();
        Toast.fire({ icon: 'success', title: wasEditing ? this.$t('guardado') : this.$t('registro_creado') });
        if (!wasEditing) this.preMaestroCurrentPage = 1;
        await this.cargarPreMaestroMateriales();
      } catch (e) {
        console.error('[guardarNuevoPreMaestro] error:', e);
        this.errorNuevoPreMaestro = (e && e.response && e.response.data && e.response.data.message) || this.$t('error_guardar_cambios');
      } finally {
        this.guardandoPreMaestro = false;
      }
    },

    async loadMaestroTaxonomias() {
      this.cargandoTaxonomias = true;
      try {
        const rows = await materialService.getTaxonomias();
        const map = Object.create(null);
        (rows || []).forEach(r => {
          const cat = String(r.Categoria || r.categoria || '').trim();
          if (!cat) return;
          map[cat] = {
            Clase:    String(r.Clase    || r.clase    || '').trim(),
            Segmento: String(r.Segmento || r.segmento || '').trim(),
            Familia:  String(r.Familia  || r.familia  || '').trim(),
          };
        });
        this.maestroTax = map;
        this.maestroCategoriaOptions = Object.keys(map).sort((a, b) => a.localeCompare(b, 'es', { sensitivity: 'base' }));
      } catch (e) {
        console.warn('[Maestro] no se pudieron cargar taxonomías:', e);
        this.maestroTax = Object.create(null);
        this.maestroCategoriaOptions = [];
      } finally {
        this.cargandoTaxonomias = false;
      }
    },

    marcarDirtyMaestro(row) {
      if (!this.puedeEscribir) return;
      this.$set(row, '_dirty', true);
    },

    onMaestroCategoriaChange(row) {
      if (!this.puedeEscribir) return;
      this.marcarDirtyMaestro(row);
      const tax = this.maestroTax[row.categoria];
      row.segmento = tax ? tax.Segmento : '';
      row.familia = tax ? tax.Familia : '';
      row.clase = tax ? tax.Clase : '';
    },

    async guardarMaestroRow(row) {
      if (!this.puedeEscribir) return;
      this.$set(row, '_saving', true);
      try {
        const resp = await materialService.updateMaestroMaterial(row.id, {
          brandName: row.brandName,
          partNumber: row.partNumber,
          modelo: row.modelo,
          partName: row.partName,
          detalles: row.detalles,
          categoria: row.categoria,
        });
        if (resp) {
          row.segmento = resp.segmento || '';
          row.familia = resp.familia || '';
          row.clase = resp.clase || '';
        }
        this.$set(row, '_dirty', false);
        Toast.fire({ icon: 'success', title: this.$t('guardado') });
      } catch (e) {
        console.error('[guardarMaestroRow] error:', e);
        Toast.fire({ icon: 'error', title: this.$t('error_guardar_cambios') });
      } finally {
        this.$set(row, '_saving', false);
      }
    },

    // ===== Scroll =====
    scrollEcommerce(dir) {
      const el = this.$refs.tablaEcommerce;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    scrollTabla(dir) {
      const el = this.$refs.tablaInventario;
      const px = 300;
      if (dir === 'left')   el && el.scrollBy({ left: -px, behavior: 'smooth' });
      if (dir === 'right')  el && el.scrollBy({ left:  px, behavior: 'smooth' });
      if (dir === 'top')    window.scrollTo({ top: 0, behavior: 'smooth' });
      if (dir === 'bottom') window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    },

    _onWindowScroll() {
      const ref = this.tipoVista === 'ecommerce'
        ? this.$refs.tablaEcommerce
        : this.tipoVista === 'maestro_materiales'
          ? this.$refs.tablaMaestro
          : this.tipoVista === 'pre_maestro_materiales'
            ? this.$refs.tablaPreMaestro
            : this.$refs.tablaInventario;
      if (!ref) return;
      const thead = ref.querySelector('thead.thead-sticky');
      if (!thead) return;
      const top = ref.getBoundingClientRect().top;
      thead.style.transform = top < 0 ? `translateY(${-top}px)` : '';
    },

    // ===== Formato =====
    formatCellNumber(val, fmt) {
      if (fmt === 'money') return this.numberFormat(val, { locale: 'es-CL', min: 0, max: 0 });
      return this.numberFormat(val);
    },

    numberFormat(v, opts) {
      const s = String(v == null ? '' : v).trim().replace(/\./g, '').replace(',', '.');
      if (!s) return '';
      const n = Number(s);
      if (!isFinite(n)) return String(v);
      const locale = (opts && opts.locale) ? opts.locale : 'es-CL';
      const min = (opts && typeof opts.min === 'number') ? opts.min : 0;
      const max = (opts && typeof opts.max === 'number') ? opts.max : 0;
      try {
        return n.toLocaleString(locale, { minimumFractionDigits: min, maximumFractionDigits: max });
      } catch (_) {
        return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    },

    getRawNumber(val) {
      if (val == null || val === '') return '';
      const s = String(val).trim().replace(/\./g, '').replace(',', '.');
      const n = Number(s);
      return Number.isFinite(n) ? n : String(val);
    },

    // ===== Exportar =====
    async exportarExcel() {
      const empresa = (this.nombreEmpresaSeleccionada || 'todas').replace(/\s+/g, '_');
      const fecha = new Date().toISOString().slice(0, 10);
      try {
        this.cargando = true;
        if (this.tipoVista === 'maestro_materiales') {
          if (!this.maestroTotal) { alert(this.$t('no_filas_exportar')); return; }
          const resp = await materialService.getMaestroMateriales(1, this.maestroTotal, this.maestroSearch, this.maestroSortBy);
          const allRows = resp ? (resp.items || []) : [];
          if (!allRows.length) { alert(this.$t('no_filas_exportar')); return; }
          const maestroCols = [
            { key: 'id',             label: 'ID' },
            { key: 'skuInexlink',    label: this.$t('col_sku_inexlink') },
            { key: 'partName',       label: this.$t('col_partName') },
            { key: 'detalles',       label: this.$t('col_detalles') },
            { key: 'categoria',      label: this.$t('col_categoria') },
            { key: 'brandName',      label: this.$t('fabricante') },
            { key: 'partNumber',     label: this.$t('col_part_number') },
            { key: 'modelo',         label: this.$t('modelo') },
            { key: 'segmento',       label: this.$t('segmento') },
            { key: 'familia',        label: this.$t('familia') },
            { key: 'clase',          label: this.$t('clase') },
            { key: 'token',          label: this.$t('token') },
            { key: 'idOrigen',       label: this.$t('col_id_origen') },
            { key: 'fechaIntegracion', label: this.$t('col_fecha_integracion') },
          ];
          const blob = this.toXLSXBlobWithCols(allRows, maestroCols);
          this.downloadBlob(blob, `MaestroMateriales_${fecha}.xlsx`);
        } else if (this.tipoVista === 'pre_maestro_materiales') {
          if (!this.preMaestroTotal) { alert(this.$t('no_filas_exportar')); return; }
          const resp = await materialService.getPreMaestroMateriales(1, this.preMaestroTotal, this.preMaestroSearch, this.preMaestroEstado);
          // El estado es derivado, igual que en la grilla: las filas del servicio traen el booleano.
          const allRows = (resp ? (resp.items || []) : []).map(r =>
            Object.assign({}, r, { estado: r && r.integrado ? this.$t('integrado') : this.$t('pendiente') })
          );
          if (!allRows.length) { alert(this.$t('no_filas_exportar')); return; }
          const preMaestroCols = [
            { key: 'id',                 label: 'ID' },
            { key: 'skuInexlink',        label: this.$t('col_sku_inexlink') },
            { key: 'partName',           label: this.$t('col_partName') },
            { key: 'detalles',           label: this.$t('col_detalles') },
            { key: 'categoriaInexlink',  label: this.$t('col_categoria_inexlink') },
            { key: 'brandName',          label: this.$t('fabricante') },
            { key: 'partNumber',         label: this.$t('col_part_number') },
            { key: 'modelo',             label: this.$t('modelo') },
            { key: 'token',              label: this.$t('token') },
            { key: 'estado',             label: this.$t('estado') },
            { key: 'fechaCarga',         label: this.$t('col_fecha_carga') },
            { key: 'fechaIntegracion',   label: this.$t('col_fecha_integracion') },
          ];
          const blob = this.toXLSXBlobWithCols(allRows, preMaestroCols);
          this.downloadBlob(blob, `PreMaestroMateriales_${fecha}.xlsx`);
        } else if (this.tipoVista === 'ecommerce') {
          if (!this.ecommerceRows.length) { alert(this.$t('no_filas_exportar')); return; }
          const ecommerceCols = [
            ...(this.rol !== 'cliente' ? [{ key: 'empresa', label: this.$t('empresa') }] : []),
            { key: 'nombreXlsx',        label: this.$t('archivo') },
            { key: 'partName',          label: this.$t('col_partName') },
            { key: 'brandName',         label: this.$t('marca') },
            { key: 'detalles',          label: this.$t('col_detalles') },
            { key: 'categoriaInexlink', label: this.$t('categoria_inexlink') },
            { key: 'cantidad',          label: this.$t('cantidad'), isNumber: true },
            { key: 'fechaPublicacion',  label: this.$t('fecha_publicacion') },
            { key: 'linkCommerce',      label: this.$t('link') },
          ];
          const blob = this.toXLSXBlobWithCols(this.ecommerceRows, ecommerceCols);
          this.downloadBlob(blob, `PublicadoEcommerce_${empresa}_${fecha}.xlsx`);
        } else {
          const allRows = await this.collectAllRowsForExport();
          if (!allRows || allRows.length === 0) { alert(this.$t('no_filas_exportar')); return; }
          const blob = this.toXLSXBlob(allRows);
          this.downloadBlob(blob, `Materiales_${empresa}_${fecha}.xlsx`);
        }
      } finally {
        this.cargando = false;
      }
    },

    async collectAllRowsForExport() {
      const opts = { idUsuario: this.idUsuario, fecha: '1900-01-01' };
      if (this.materialTotal != null && this.materialTotal > 0 && this.materialTotal <= 5000) {
        try {
          const r = await materialService.getMaterialAll(this.empresaSeleccionada, 1, this.materialTotal, opts, this.lang);
          let items = Array.isArray(r) ? r : (r && (r.items || r.data)) || [];
          return Array.isArray(items) ? items : [];
        } catch (_) {}
      }
      const totalPages = Math.max(1, Number(this.totalPagesServer || 1));
      const CONC = 8;
      const collected = [];
      const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
      for (let i = 0; i < pages.length; i += CONC) {
        const batch = pages.slice(i, i + CONC);
        await Promise.all(batch.map(p =>
          materialService.getMaterialAll(this.empresaSeleccionada, p, this.pageSize, opts, this.lang)
            .then(resp => {
              let items = Array.isArray(resp) ? resp : (resp && (resp.items || resp.data)) || [];
              if (Array.isArray(items)) collected.push(...items);
            })
            .catch(e => console.warn('[Export] error en página', p, e))
        ));
      }
      return collected;
    },

    toXLSXBlobWithCols(rows, cols) {
      const header = cols.map(c => c.label || c.key);
      const data = [header, ...rows.map(r =>
        cols.map(c => {
          const v = r[c.key];
          if (c.isNumber) {
            const n = this.getRawNumber(v);
            return (typeof n === 'number' && isFinite(n)) ? n : (n === '' ? null : String(v == null ? '' : v));
          }
          return v == null ? '' : v;
        })
      )];
      const ws = XLSX.utils.aoa_to_sheet(data);
      ws['!cols'] = header.map(h => ({ wch: Math.max(10, String(h).length + 2) }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Datos');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      return new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    },

    toXLSXBlob(rows) {
      const cols = this.exportColumns;
      const header = cols.map(c => c.label || c.key);
      const data = [header, ...rows.map(r =>
        cols.map(c => {
          const v = r[c.key];
          if (c.isNumber) {
            const n = this.getRawNumber(v);
            return (typeof n === 'number' && isFinite(n)) ? n : (n === '' ? null : String(v == null ? '' : v));
          }
          return v == null ? '' : v;
        })
      )];
      const ws = XLSX.utils.aoa_to_sheet(data);
      ws['!cols'] = header.map(h => ({ wch: Math.max(10, String(h).length + 2) }));
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Materiales');
      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      return new Blob([wbout], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    },

    downloadBlob(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = filename;
      document.body.appendChild(a); a.click();
      setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 0);
    },
  },
}
</script>

<style scoped>
/* ===== Tabla con scroll horizontal fijo ===== */
.tabla-scroll-fixed {
  overflow-x: auto;
  width: 100%;
  position: relative;
  /* La barra de paginación es position:fixed, así que flota por encima del final
     de la página. Sin esta reserva la última fila queda tapada por ella. Va como
     margin y no padding para que la barra de scroll horizontal del contenedor
     tampoco caiga debajo del pie. */
  margin-bottom: 60px;
}

.tabla-scroll-fixed .table th,
.tabla-scroll-fixed .table td {
  font-size: 12px;
}

/* ===== Thead sticky ===== */
.thead-sticky {
  position: relative;
  z-index: 2;
  background: #f8f9fa;
}

/* ===== Columnas ordenables ===== */
.th-ordenable {
  cursor: pointer;
  user-select: none;
  min-width: 90px;
  vertical-align: top;
  white-space: nowrap;
}
.th-ordenable:hover {
  background-color: #e9ecef !important;
}

.th-search-input {
  width: 100%;
  font-size: 11px;
  padding: 2px 4px;
  border: 1px solid #ced4da;
  border-radius: 3px;
  margin-bottom: 3px;
  display: block;
  font-weight: normal;
}

.th-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

/* ===== Botones de scroll ===== */
.btn-scroll-nav {
  width: 32px;
  height: 32px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ced4da;
  background: #f8f9fa;
  color: #495057;
  border-radius: 6px;
}
.btn-scroll-nav:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

/* ===== Barra flotante de paginación ===== */
.pagination-floating-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 500;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  background: #fff;
  border-top: 1px solid #dee2e6;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
}

/* ===== Maestro de Materiales: tabla más compacta ===== */
.tabla-maestro-compacta .table th,
.tabla-maestro-compacta .table td {
  font-size: 11px;
  padding: 4px 6px;
}
.tabla-maestro-compacta .th-label {
  font-size: 11px;
}
.tabla-maestro-compacta .th-search-input {
  font-size: 10px;
}
.tabla-maestro-compacta .form-control-sm {
  font-size: 11px;
  padding: 2px 4px;
  height: calc(1.5em + 4px);
}
.tabla-maestro-compacta .el-select .el-input__inner {
  font-size: 11px;
  height: 26px;
  line-height: 26px;
}
.tabla-maestro-compacta .btn-sm {
  font-size: 11px;
  padding: 2px 6px;
}

/* Fila con cambios sin guardar */
.tabla-maestro-compacta tr.fila-modificada > td {
  background-color: rgba(220, 53, 69, 0.08);
}

/* Botón Guardar palpitando mientras haya cambios sin guardar */
@keyframes pulseGuardar {
  0% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.6); }
  70% { box-shadow: 0 0 0 7px rgba(40, 167, 69, 0); }
  100% { box-shadow: 0 0 0 0 rgba(40, 167, 69, 0); }
}
.btn-pulse {
  animation: pulseGuardar 1.4s infinite;
}

/* ===== Celda truncada con tooltip nativo ===== */
.td-truncate {
  max-width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== Toolbar de filtros ===== */
.filtros-toolbar {
  padding-bottom: 4px;
}
.filtro-item label {
  font-weight: 600;
  color: #525f7f;
}

/* Separa las acciones que escriben en el Maestro de las que solo cargan o exportan.
   Va como inline-block y no como flex para no alterar el resto de la barra, que la
   comparten las otras vistas. */
.separador-acciones {
  display: inline-block;
  width: 1px;
  height: 26px;
  margin: 0 1.5rem;
  background-color: #dee2e6;
  vertical-align: middle;
}
</style>
